<template>
  <div
  class="main-table"
  :class="[table_section + '__vue-table ', 'main-table_' + table_language, 'main_table_status_' + table_main]"
  >
    <!--фильтр-->
    <div v-if="(table_section == 'exchanges' || table_section == 'wallets') && table_filter_options_src" class="container">
      <div class="filter">
        <div class="filter__controls">
            <a href="#" class="js-filter-hide danger" @click.prevent="showFilter('hide')" style="display: none;">
              <svg class="i i-arrow">
                  <use xlink:href="/themes/finliners/assets/src/svg/sprites/sprite.svg#i-arrow"></use>
              </svg>
              <span>{{ filtersLang.filters_hide }}</span>
            </a>
            <a href="#" class="js-filter-show success" @click.prevent="showFilter('show')">
              <svg class="i i-arrow">
                  <use xlink:href="/themes/finliners/assets/src/svg/sprites/sprite.svg#i-arrow"></use>
              </svg>
              <span>{{ filtersLang.filters_show }}</span>
            </a>
            <a href="#" class="js-filter-reset cancel" @click.prevent="showFilter('cansel')" style="display: none;">
              <svg class="i i-cancel">
                  <use xlink:href="/themes/finliners/assets/src/svg/sprites/sprite.svg#i-cancel"></use>
              </svg>
              <span>{{ filtersLang.filters_reset }}</span>
            </a>
          </div>
          <div class="js-filter-wrap" style="display: none;">
            <div class="row filter__row">
              <!--фильтр платформы wallets -->
              <div v-if="filterCol_wallets_platforms.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.wallets_platforms }}</div>
                <div class="filter__list filter__list--scroll js-filter-scroll">
                  <label v-for="platform in filterCol_wallets_platforms" class="filter__field js-filter-search-item" :data-value="platform.name">
                    <input
                      type="checkbox"
                      :value="platform.id"
                      v-model="walletsPlatformsIdsFiltered"
                      @change="filterExchanges('platforms',walletsPlatformsIdsFiltered);"
                      name="platforms" />
                    <div class="filter__radio">
                      <img v-if="platform.logo && platform.logo.path" :src="platform.logo.path" width="16" height="16" />
                      <span>{{ platform.name }}</span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр валют-->
              <div v-if="filterCol_currencies.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.currency }}</div>
                <div class="rel js-filter-search">
                  <div class="filter__search">
                    <label class="context-search" for="context-search-currency">
                      <div class="context-search__icon">
                        <svg class="i i-search">
                            <use xlink:href="/themes/finliners/assets/src/svg/sprites/sprite.svg#i-search"></use>
                        </svg>
                      </div>
                      <input class="context-search__field js-filter-search-input" id="context-search-currency" :placeholder="filtersLang.currency_search">
                    </label>
                  </div>
                  <div class="filter__list filter__list--search filter__list--scroll js-filter-scroll">
                    <label v-for="currency in filterCol_currencies" class="filter__field js-filter-search-item" :data-value="currency.name">
                      <input
                        type="checkbox"
                        :value="currency.id"
                        v-model="exchangesCurrenciesIdsFiltred"
                        @change="filterExchanges('currency_ids',exchangesCurrenciesIdsFiltred);"
                        name="currency_ids" />
                      <div class="filter__radio">
                          <picture>
                              <source
                                  :srcset="currency.images['desktop']['16x16']['webp'] + ' 1x, '+currency.images['desktop']['32x32']['webp'] + ' 2x'"
                                  :type="'image/webp'"
                              >
                              <img
                                  :src="currency.images['desktop']['16x16']['png']"
                                  :srcset="currency.images['desktop']['32x32']['png'] + ' 2x'"
                                  :loading="'lazy'" width="16" height="16"
                              />
                          </picture>
                        <span>{{ currency.name }}</span>
                        <div class="filter__badge">0</div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <!--фильтр валют wallets-->
              <div v-if="filterCol_wallets_currencies.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.currency }}</div>
                <div class="rel js-filter-search">
                  <div class="filter__search">
                    <label class="context-search" for="context-search-currency">
                      <div class="context-search__icon">
                        <svg class="i i-search">
                            <use xlink:href="/themes/finliners/assets/src/svg/sprites/sprite.svg#i-search"></use>
                        </svg>
                      </div>
                      <input class="context-search__field js-filter-search-input" id="context-search-currency" :placeholder="filtersLang.currency_search">
                    </label>
                  </div>
                  <div class="filter__list filter__list--search filter__list--scroll js-filter-scroll">
                    <label v-for="currency in filterCol_wallets_currencies" class="filter__field js-filter-search-item" :data-value="currency.name">
                      <input
                        type="checkbox"
                        :value="currency.id"
                        v-model="walletsCurrenciesIdsFiltered"
                        @change="filterExchanges('currencies',walletsCurrenciesIdsFiltered);"
                        name="currencies" />
                      <div class="filter__radio">
                          <picture>
                              <source
                                  :srcset="currency.images['desktop']['16x16']['webp'] + ' 1x, '+currency.images['desktop']['32x32']['webp'] + ' 2x'"
                                  :type="'image/webp'"
                              >
                              <img
                                  :src="currency.images['desktop']['16x16']['png']"
                                  :srcset="currency.images['desktop']['32x32']['png'] + ' 2x'"
                                  :loading="'lazy'" width="16" height="16"
                              />
                          </picture>
                        <span>{{ currency.name }}</span>
                        <div class="filter__badge">0</div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <!--фильтр опции-->
              <div v-if="filterCol_functionality.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.functionality }}</div>
                <div class="filter__list filter__list--scroll js-filter-scroll">
                  <label v-for="functionality_option in filterCol_functionality" class="filter__field">
                    <input
                      type="checkbox"
                      :value="functionality_option.name"
                      v-model="exchangesFunctionalityFiltred"
                      @change="filterExchanges('functionality',exchangesFunctionalityFiltred);"
                      name="functionality" />
                    <div class="filter__radio">
                      <span v-if="functionality_option.name == 'is_decentralized'">{{ filtersLang.is_decentralized }}</span>
                      <span v-if="functionality_option.name == 'is_margin_trading'">{{ filtersLang.is_margin_trading }}</span>
                      <span v-if="functionality_option.name == 'is_derivatives'">{{ filtersLang.is_derivatives }}</span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр фиаты-->
              <div v-if="filterCol_fiats.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.fiat }}</div>
                <div class="filter__list filter__list--scroll js-filter-scroll">
                  <label v-for="fiat in filterCol_fiats" class="filter__field js-filter-search-item" :data-value="fiat.name">
                    <input
                      type="checkbox"
                      :value="fiat.id"
                      v-model="exchangesFiatsIdsFiltred"
                      @change="filterExchanges('fiat_ids',exchangesFiatsIdsFiltred);"
                      name="fiat_ids" />
                    <div class="filter__radio">
                      <i class="fas" v-if="fiat.icon" :class="'fa-' + fiat.icon"></i>
                      <span>{{ fiat.code }}</span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр платежные системы-->
              <div v-if="filterCol_pays.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.pay }}</div>
                <div class="filter__list filter__list--scroll js-filter-scroll">
                  <label v-for="pay in filterCol_pays" class="filter__field js-filter-search-item" :data-value="pay.name">
                    <input
                      type="checkbox"
                      :value="pay.id"
                      v-model="exchangesPaymentsIdsFiltred"
                      @change="filterExchanges('payment_ids',exchangesPaymentsIdsFiltred);"
                      name="payment_ids" />
                    <div class="filter__radio">
                        <picture v-if="pay.logo" class="vue-table__row_name_logo">
                            <source

                                :srcset="pay.images['desktop']['16x16']['webp'] + ' 1x, '+pay.images['desktop']['32x32']['webp'] + ' 2x'"
                                :type="'image/webp'"
                            >
                            <img
                                :src="pay.images['desktop']['16x16']['png']"
                                :srcset="pay.images['desktop']['32x32']['png'] + ' 2x'"
                                :loading="'lazy'"
                                class="vue-table__row_name_logo" width="16" height="16"
                            />
                        </picture>
                      <span>{{ pay.name }}</span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр Private key  wallets-->
              <div v-if="filterCol_wallets_private_key_options.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.wallets_private_key_options }}</div>
                <div class="filter__list filter__list--scroll js-filter-scroll">
                  <label v-for="key in filterCol_wallets_private_key_options" class="filter__field js-filter-search-item" :data-value="key.label">
                    <input
                      type="checkbox"
                      :value="key.value"
                      v-model="walletsPrivateKeyOptionsIdsFiltered"
                      @change="filterExchanges('private_key',walletsPrivateKeyOptionsIdsFiltered);"
                      name="private_key" />
                    <div class="filter__radio">
                      <template v-if='key.value == "1" '>
                        <svg class="i i-lock icon--fill-success table__icons" viewBox="0 0 401.998 401.998">
                          <path d="M357.45 190.721c-5.331-5.33-11.8-7.993-19.417-7.993h-9.131v-54.821c0-35.022-12.559-65.093-37.685-90.218C266.093 12.563 236.025 0 200.998 0c-35.026 0-65.1 12.563-90.222 37.688-25.126 25.126-37.685 55.196-37.685 90.219v54.821h-9.135c-7.611 0-14.084 2.663-19.414 7.993-5.33 5.326-7.994 11.799-7.994 19.417V374.59c0 7.611 2.665 14.086 7.994 19.417 5.33 5.325 11.803 7.991 19.414 7.991H338.04c7.617 0 14.085-2.663 19.417-7.991 5.325-5.331 7.994-11.806 7.994-19.417V210.135c.004-7.612-2.669-14.084-8.001-19.414zm-83.363-7.993H127.909v-54.821c0-20.175 7.139-37.402 21.414-51.675 14.277-14.275 31.501-21.411 51.678-21.411 20.179 0 37.399 7.135 51.677 21.411 14.271 14.272 21.409 31.5 21.409 51.675v54.821z"></path>
                        </svg>
                        <span>{{ table_language == 'en' ? key.label : 'Хранится на устройстве пользователя' }}</span>
                      </template>
                      <template v-else-if='key.value == "2" '>
                        <svg class="i i-lock icon--fill-danger table__icons" viewBox="0 0 401.998 401.998">
                          <path d="M357.45 190.721c-5.331-5.33-11.8-7.993-19.417-7.993h-9.131v-54.821c0-35.022-12.559-65.093-37.685-90.218C266.093 12.563 236.025 0 200.998 0c-35.026 0-65.1 12.563-90.222 37.688-25.126 25.126-37.685 55.196-37.685 90.219v54.821h-9.135c-7.611 0-14.084 2.663-19.414 7.993-5.33 5.326-7.994 11.799-7.994 19.417V374.59c0 7.611 2.665 14.086 7.994 19.417 5.33 5.325 11.803 7.991 19.414 7.991H338.04c7.617 0 14.085-2.663 19.417-7.991 5.325-5.331 7.994-11.806 7.994-19.417V210.135c.004-7.612-2.669-14.084-8.001-19.414zm-83.363-7.993H127.909v-54.821c0-20.175 7.139-37.402 21.414-51.675 14.277-14.275 31.501-21.411 51.678-21.411 20.179 0 37.399 7.135 51.677 21.411 14.271 14.272 21.409 31.5 21.409 51.675v54.821z"></path>
                        </svg>
                        <span>{{ table_language == 'en' ? key.label : 'Хранится на сервере, незашифрован' }}</span>
                      </template>
                      <template v-else>
                        <svg class="i i-lock icon--fill-primary table__icons" viewBox="0 0 401.998 401.998">
                          <path d="M357.45 190.721c-5.331-5.33-11.8-7.993-19.417-7.993h-9.131v-54.821c0-35.022-12.559-65.093-37.685-90.218C266.093 12.563 236.025 0 200.998 0c-35.026 0-65.1 12.563-90.222 37.688-25.126 25.126-37.685 55.196-37.685 90.219v54.821h-9.135c-7.611 0-14.084 2.663-19.414 7.993-5.33 5.326-7.994 11.799-7.994 19.417V374.59c0 7.611 2.665 14.086 7.994 19.417 5.33 5.325 11.803 7.991 19.414 7.991H338.04c7.617 0 14.085-2.663 19.417-7.991 5.325-5.331 7.994-11.806 7.994-19.417V210.135c.004-7.612-2.669-14.084-8.001-19.414zm-83.363-7.993H127.909v-54.821c0-20.175 7.139-37.402 21.414-51.675 14.277-14.275 31.501-21.411 51.678-21.411 20.179 0 37.399 7.135 51.677 21.411 14.271 14.272 21.409 31.5 21.409 51.675v54.821z"></path>
                        </svg>
                        <span>{{ table_language == 'en' ? key.label : 'Хранится на сервере, зашифрован' }}</span>
                      </template>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр страна-->
              <div v-if="filterCol_countries.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.country }}</div>
                <div class="filter__list filter__list--scroll js-filter-scroll">
                  <label v-for="country in filterCol_countries" class="filter__field js-filter-search-item" :data-value="country.name">
                    <input
                      type="checkbox"
                      :value="country.id"
                      v-model="exchangesCountriesIdsFiltred"
                      @change="filterExchanges('country_id',exchangesCountriesIdsFiltred);"
                      name="country_id" />
                    <div class="filter__radio">
                      <img :src="'/modules/system/assets/ui/vendor/flag-icon/flags/4x3/' + ((country.code).toLowerCase()) + '.svg'" width="16" height="16" />
                      <span>{{ country.name }}</span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр языки-->
              <div v-if="filterCol_languages.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.language }}</div>
                <div class="filter__list filter__list--scroll js-filter-scroll">
                  <label v-for="language in filterCol_languages" class="filter__field js-filter-search-item" :data-value="language.name">
                    <input
                      type="checkbox"
                      :value="language.id"
                      v-model="exchangesLanguagesIdsFiltred"
                      @change="filterExchanges('language_ids',exchangesLanguagesIdsFiltred);"
                      name="language_ids" />
                    <div class="filter__radio">
                      <span>{{ language.name }}</span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр языки wallets-->
              <div v-if="filterCol_wallets_languages.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.language }}</div>
                <div class="filter__list filter__list--scroll js-filter-scroll">
                  <label v-for="language in filterCol_wallets_languages" class="filter__field js-filter-search-item" :data-value="language.name">
                    <input
                      type="checkbox"
                      :value="language.id"
                      v-model="walletsLanguagesIdsFiltered"
                      @change="filterExchanges('language_wallets',walletsLanguagesIdsFiltered);"
                      name="language_wallets" />
                    <div class="filter__radio">
                      <span>{{ language.name }}</span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>

            </div>
            <div class="row filter__row">

              <!--фильтр has_2fa_options wallets-->
              <div v-if="filterCol_wallets_has_2fa_options.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.wallets_has_2fa_options }}</div>
                <div class="filter__list filter__list--small filter__list--scroll js-filter-scroll">
                  <label v-for="has_2fa_option in filterCol_wallets_has_2fa_options" class="filter__field js-filter-search-item" :data-value="has_2fa_option.label">
                    <input
                      type="checkbox"
                      :value="has_2fa_option.value"
                      v-model="walletsHas2faOptionsIdsFiltered"
                      @change="filterExchanges('has_2fa',walletsHas2faOptionsIdsFiltered);"
                      name="has_2fa" />
                    <div class="filter__radio">
                      <span v-if="has_2fa_option.value == '1' ">
                         {{ table_language == 'en' ? has_2fa_option.label : 'Да' }}
                      </span>
                      <span v-else>
                        {{ table_language == 'en' ? has_2fa_option.label : 'Нет' }}
                      </span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр has_multisignature_options wallets-->
              <div v-if="filterCol_wallets_has_multisignature_options.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.wallets_has_multisignature_options }}</div>
                <div class="filter__list filter__list--small filter__list--scroll js-filter-scroll">
                  <label v-for="has_multisignature_option in filterCol_wallets_has_multisignature_options" class="filter__field js-filter-search-item" :data-value="has_multisignature_option.label">
                    <input
                      type="checkbox"
                      :value="has_multisignature_option.value"
                      v-model="walletsHasMultisignatureOptionsIdsFiltered"
                      @change="filterExchanges('has_multisignature',walletsHasMultisignatureOptionsIdsFiltered);"
                      name="has_multisignature" />
                    <div class="filter__radio">
                      <span v-if="has_multisignature_option.value == '1' ">
                          {{ table_language == 'en' ? has_multisignature_option.label : 'Да' }}
                      </span>
                      <span v-else>
                        {{ table_language == 'en' ? has_multisignature_option.label : 'Нет' }}
                      </span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр functionality wallets-->
              <div v-if="filterCol_wallets_functionality.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.wallets_functionality }}</div>
                <div class="filter__list filter__list--small filter__list--scroll js-filter-scroll">
                  <label v-for="functionality in filterCol_wallets_functionality" class="filter__field js-filter-search-item" :data-value="functionality.label">
                    <input
                      type="checkbox"
                      :value="functionality.value"
                      v-model="walletsFunctionalityIdsFiltered"
                      @change="filterExchanges('functionality_wallets',walletsFunctionalityIdsFiltered);"
                      name="functionality_wallets" />
                    <div class="filter__radio">
                      <span v-if="functionality.label == 'has_buysell'">{{ filtersLang.has_buysell }}</span>
                      <span v-if="functionality.label == 'has_exchange'">{{ filtersLang.has_exchange }}</span>
                      <span v-if="functionality.label == 'has_debitcard'">{{ filtersLang.has_debitcard }}</span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр is_opensource_options wallets-->
              <div v-if="filterCol_wallets_is_opensource_options.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.wallets_is_opensource_options }}</div>
                <div class="filter__list filter__list--small filter__list--scroll js-filter-scroll">
                  <label v-for="is_opensource_option in filterCol_wallets_is_opensource_options" class="filter__field js-filter-search-item" :data-value="is_opensource_option.label">
                    <input
                      type="checkbox"
                      :value="is_opensource_option.value"
                      v-model="walletsIsOpensourceOptionsIdsFiltered"
                      @change="filterExchanges('is_opensource',walletsIsOpensourceOptionsIdsFiltered);"
                      name="is_opensource" />
                    <div class="filter__radio">
                      <span v-if="is_opensource_option.value == '1' ">
                          {{ table_language == 'en' ? is_opensource_option.label : 'Да' }}
                      </span>
                      <span v-else>
                        {{ table_language == 'en' ? is_opensource_option.label : 'Нет' }}
                      </span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
              <!--фильтр has_newbie_alert_options wallets-->
              <div v-if="filterCol_wallets_has_newbie_alert_options.length > 0" class="filter__item">
                <div class="filter__title">{{ filtersLang.wallets_has_newbie_alert_options }}</div>
                <div class="filter__list filter__list--small filter__list--scroll js-filter-scroll">
                  <label v-for="has_newbie_alert_option in filterCol_wallets_has_newbie_alert_options" class="filter__field js-filter-search-item" :data-value="has_newbie_alert_option.label">
                    <input
                      type="checkbox"
                      :value="has_newbie_alert_option.value"
                      v-model="walletsHasNewbieAlertOptionsIdsFiltered"
                      @change="filterExchanges('has_newbie_alert',walletsHasNewbieAlertOptionsIdsFiltered);"
                      name="has_newbie_alert" />
                    <div class="filter__radio">
                      <span v-if="has_newbie_alert_option.value == '1' ">
                          {{ table_language == 'en' ? has_newbie_alert_option.label : 'Не для новичков' }}
                      </span>
                      <span v-else>
                        {{ table_language == 'en' ? has_newbie_alert_option.label : 'Без ограничений' }}
                      </span>
                      <div class="filter__badge">0</div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <!--фильтр-->
    <div
    class="toolbar mt-35 mb-20"
    v-if="table_section == 'exchangeItem'"
    >
      <div class="container">
        <div class="toolbar__content toolbar__content--left">
          <ul class="toolbar__list">
            <li
            :class="{'active': exchangesFiltresActive == 'all'}"
            >
              <div
              class="js-pair exchanges-filtres__item exchanges-filtres__item_all"
              data-all="true"
              @click="filterColumn('all', ''); exchangesFiltresActive = 'all'"
              >
                {{ table_language == 'en' ? 'All' : 'Все' }}
              </div>
            </li>
          </ul>

          <ul v-if="exchangesCurrenciesFiltres.length > 0 && !isMobile" class="toolbar__list fiat">
            <li
            v-for="fiat in exchangesCurrenciesFiltres"
            :class="{'active': exchangesFiltresActive == fiat.name}"
            >
              <div
              class="js-pair exchanges-filtres__item"
              @click="filterColumn(fiat.section, fiat.name); exchangesFiltresActive = fiat.name"
              >
                {{ fiat.name }}
              </div>
            </li>
          </ul>

          <div v-if="exchangesFiltres.length > 0 || exchangesCurrenciesFiltres.length > 0" class="flex toolbar__group js-swipe-scroller js-swipe-scroller_vue" id="scroller">
            <ul class="toolbar__list toolbar__list--arrow">
              <li>
                <a href="#" class="toolbar__prev js-arrow" data-direction="-1">
                  <svg class="i i-arrow">
                      <use xlink:href="/themes/finliners/assets/src/svg/sprites/sprite.svg#i-arrow"></use>
                  </svg>
                </a>
              </li>
            </ul>
            <div class="toolbar__scroll-wrap js-content">
              <div class="toolbar__scroller js-scroller">
                <ul class="toolbar__list js-swipe-element">
                  <li
                   v-for="fiat in exchangesCurrenciesFiltres" v-if="isMobile"
                  :class="{'active': exchangesFiltresActive == fiat.name}"
                  >
                    <div
                    class="js-pair exchanges-filtres__item"
                    @click="filterColumn(fiat.section, fiat.name); exchangesFiltresActive = fiat.name"
                    >
                      {{ fiat.name }}
                    </div>
                  </li>
                  <li
                  v-for="wallet in exchangesFiltres"
                  :class="{'active': exchangesFiltresActive == wallet.name}"
                  >
                    <div
                    class="js-pair exchanges-filtres__item"
                    @click="filterColumn(wallet.section, wallet.name); exchangesFiltresActive = wallet.name"
                    >
                      {{ wallet.name }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <ul class="toolbar__list toolbar__list--arrow">
              <li>
                <a href="#" class="toolbar__next js-arrow" data-direction="1">
                  <svg class="i i-arrow">
                      <use xlink:href="/themes/finliners/assets/src/svg/sprites/sprite.svg#i-arrow"></use>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
          <div class="toolbar__stat">
            <template v-if="table_language == 'en'">Currencies total:</template>
            <template v-else>Всего валют:</template>
            <span>{{ exchangesFiltres.length + exchangesCurrenciesFiltres.length }}</span>
          </div>
        </div>
      </div>
    </div>

    <div
    class="toolbar mt-40 mb-20"
    v-if="table_section == 'currencies' && !isMobile && !table_main"
    >
      <div class="container">
        <div class="toolbar__content">
          <ul class="toolbar__list js-table-filter" data-target="tableOne">
            <li
            :class="{active:selectedFilter==='all'}"
            >
              <a
              href="#"
              @click="filterColumn('all', '')"
              >
                <div
                v-if="table_language == 'en'"
                >
                  All
                </div>
                <div
                v-else="table_language == 'ru'"
                >
                  Все
                </div>
                <span class="small"> {{ tableData.length }}</span>
              </a>
            </li>
            <li
            :class="{active:selectedFilter==='coins'}"
            >
              <a
              href="#"
              @click="filterColumn('coins', true)"
              >
                <div
                v-if="table_language == 'en'"
                >
                  Coins
                </div>
                <div
                v-else="table_language == 'ru'"
                >
                  Монеты
                </div>
                <span class="small">{{ coinsCount }}</span></a>
            </li>
            <li
            :class="{active:selectedFilter==='tokens'}"
            >
              <a
              href="#"
              @click="filterColumn('tokens', true)"
              >
                <div
                v-if="table_language == 'en'"
                >
                  Tokens
                </div>
                <div
                v-else="table_language == 'ru'"
                >
                  Токены
                </div>
                <span class="small">{{ tokensCount }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
<div class="container">
    <div
    class="vue__total-pairs"
    :class="{'pagination_disable': !paginationDisable}"
    v-if="table_section == 'exchangeItem'"
    >
      <div class="vue__total-pairs__title">
        <template v-if="table_language == 'en'">Total {{ exchangesFiltresActive }} pairs: </template>
        <template v-else>Всего пар:</template>
        {{ filteredData }}
      </div>
    </div>

    <div
    class="vue-table__headings__mob"
    :class="{'popup_active': mobPopup}"
    v-if="isMobile"
    >
      <div class="vue-table__headings__mob__wrapper">
        <div
        class="vue-table__popup__but vue-table__headings__wallets vue-table__headings__item"
        v-if="mob_wallets != null && table_section == 'exchangeItem2' "
        @click="mobWalletChange()"
        >
          <div
          class="vue-table__headings__title"
          >
            {{ mobWallet }}
          </div>
        </div>
        <div
        class="vue-table__popup__but vue-table__headings__sort vue-table__headings__item"
        v-if="mobHeadings.length > 0"
        >
          <div class="vue-table__headings__title">
            <div
            @click="toggleMobilePopup('Sort by', mobHeadings, 'sorting'); mobPopup = !mobPopup"
            v-if="table_language == 'en'"
            >
              Sort by {{ selected_sort }}
            </div>
            <div
            @click="toggleMobilePopup('Сортировать по', mobHeadings, 'sorting'); mobPopup = !mobPopup"
            v-if="table_language == 'ru'"
            >
              Сортировать по {{ selected_sort }}
            </div>
            <div
            class="vue-table__headings__sort__arrow"
            :class="{ active: !ascending }"
            v-if="typeof ascending == 'boolean' || selected_sort_section"
            @click="sortColumn({ascending:true, column:selected_sort_section}, selected_sort); ascending = !ascending"
            ></div>
          </div>
        </div>
        <div
        class="vue-table__popup__but vue-table__headings__filter vue-table__headings__item"
        v-if="mobCrypto.length > 0 && table_language == 'en'"
        @click="toggleMobilePopup('Looking for', mobCrypto, 'filter'); mobPopup = !mobPopup"
        >
          <div v-if="selectedFilter == 'all' "
          class="vue-table__headings__title"
          >
            All Cryptocurrencies
          </div>
          <div v-if="selectedFilter == 'tokens' "
          class="vue-table__headings__title"
          >
            Tokens
          </div>
          <div v-if="selectedFilter == 'coins' "
          class="vue-table__headings__title"
          >
            Coins
          </div>
        </div>
        <div
        class="vue-table__popup__but vue-table__headings__filter vue-table__headings__item"
        v-if="mobCrypto.length > 0 && table_language == 'ru'"
        @click="toggleMobilePopup('Показать', mobCrypto, 'filter'); mobPopup = !mobPopup"
        >
          <div v-if="selectedFilter == 'all' "
          class="vue-table__headings__title"
          >
            Все криптовалюты
          </div>
          <div v-if="selectedFilter == 'tokens' "
          class="vue-table__headings__title"
          >
            Токены
          </div>
          <div v-if="selectedFilter == 'coins' "
          class="vue-table__headings__title"
          >
            Монеты
          </div>
        </div>

        <transition name="fade">
          <div
          class="vue-table__popup vue-table__popup_sort"
          v-if="mobPopup"
          >
            <div class="vue-table__headings__sort__list__title">
              {{ mobPopupName }}
            </div>
            <div class="vue-table__headings__sort__list">
              <div
              class="table__headings__sort__item"
              v-for="item in mobPopupSection"
              v-if="mobPopupMethod == 'sorting'"
              @click="sortColumn({ascending:true, column:item.section}, item.name); mobPopup = !mobPopup"
              >
                {{ item.name }}
                <!--<div
                v-if="ascending != null && item.name == selected_sort"
                :class="{ active: ascending }"
                ></div>-->
              </div>
              <div
              class="table__headings__sort__item"
              v-for="item in mobPopupSection"
              v-if="mobPopupMethod == 'filter'"
              @click="filterColumn(item.section, item.params); mobPopup = !mobPopup"
              >
                {{ item.name }}
              </div>
            </div>
            <div
            class="vue-table__popup__overlay"
            @click="mobPopup = !mobPopup"
            ></div>
          </div>
        </transition>
      </div>
    </div>

    <v-client-table
    :data="tableData"
    :columns="columns"
    :options="options"
    ref="table"
    >
      <template slot="country" slot-scope="props" v-if='table_section=="exchanges"'>
            <img
            v-if="props.row.country_img != ''"
            :src="props.row.country_img"
            class="table__logo"
            alt=""
            width="19"
            height="14"
            >
            {{ props.row.country }}
      </template>

      <template slot="name" slot-scope="props">
         <div>
              <a
              class="vue-table__row_name"
              :href="table_language != 'en' ? '/' + table_language + '/' + table_section + '/' + props.row.slug : '/' + table_section + '/' + props.row.slug"
              >
                <div class="vue-table__row_name_logo" v-if="props.row.logo != ''">
                    <picture v-if="isMobile" class="vue-table__row_name_logo">
                        <source
                            :srcset="props.row.images['mobile']['26x26']['webp'] + ' 1x, '+props.row.images['mobile']['52x52']['webp'] + ' 2x'"
                            :type="'image/webp'"
                        >
                        <img
                            :src="props.row.images['mobile']['26x26']['png']"
                            :srcset="props.row.images['mobile']['52x52']['png'] + ' 2x'"
                            :loading="'lazy'"
                            class="vue-table__row_name_logo" width="16" height="16"
                        />
                    </picture>
                    <picture v-else class="vue-table__row_name_logo">
                        <source

                            :srcset="props.row.images['desktop']['16x16']['webp'] + ' 1x, '+props.row.images['desktop']['32x32']['webp'] + ' 2x'"
                            :type="'image/webp'"
                        >
                        <img
                            :src="props.row.images['desktop']['16x16']['png']"
                            :srcset="props.row.images['desktop']['32x32']['png'] + ' 2x'"
                            :loading="'lazy'"
                            class="vue-table__row_name_logo" width="16" height="16"
                        />
                    </picture>
                </div>
                <div
                v-else
                class="vue-table__row_name_logo"
                ></div>
                <div class="vue-table__row_wrapper">
                  <div
                  class="vue-table__row_name_name"
                  v-if="!isMobile"
                  >
                    {{ props.row.name }}
                  </div>
                  <div
                  class="vue-table__row_name_name"
                  v-if="isMobile"
                  >
                    {{ props.row.name | truncate(13, '...') }}
                  </div>
                  <div
                  class="vue-table__row_wrapper"
                  v-if="isMobile"
                  >
                    <div
                    class="vue-table__row_name_code"
                    v-if='table_section=="currencies" && !isMobile'
                    >
                      {{ props.row.code }}
                    </div>
                    <div
                    class="vue-table__row_name_code"
                    v-if='table_section=="currencies" && isMobile'
                    >
                      {{ props.row.code | truncate(13, '...') }}
                    </div>
                    <div
                    v-if='table_section=="currencies" && isMobile'
                    class="vue-table__row_price-delta"
                    :class="props.row.price_usd_delta > 0 ? 'vue-table__row_int_plus' : props.row.price_usd_delta < 0 ? 'vue-table__row_int_minus' : ''"
                    >
                      {{ props.row.price_usd_delta }}%
                    </div>
                    <div
                    v-if='table_section=="exchanges" && isMobile'
                    class="vue-table__row_country__list"
                    >
                      <img
                      :src="props.row.country_img"
                      style="max-width: 15px;"
                      alt=""
                      width="19"
                        height="14"
                      >
                    </div>
                    <div
                    v-if='table_section=="exchanges" && isMobile'
                    class="vue-table__row_price-delta"
                    :class="props.row.volume_24_usd_delta > 0 ? 'vue-table__row_int_plus' : props.row.volume_24_usd_delta < 0 ? 'vue-table__row_int_minus' : ''"
                    >
                      {{ props.row.volume_24_usd_delta }}%
                    </div>
                  </div>
                </div>
              </a>
          </div>
      </template>

      <template slot="currencies_count" slot-scope="props">
         <div class="vue-table__row_currencies vue-table__row_wrapper">
              <div>{{ props.row.currencies_count }}</div>
              <div
              v-if="isMobile"
              >
                {{ table_language == 'en' ? 'cur' : 'валют' }}
              </div>
          </div>
      </template>

      <template slot="exchange_name" slot-scope="props">
         <div>
              <a
              class="vue-table__row_name"
              :href="table_language != 'en' ? '/' + table_language + '/' + 'exchanges' + '/' + props.row.exchange_slug : '/' + 'exchanges' + '/' + props.row.exchange_slug"
              v-if="table_section != 'currencyItem_tabTwo'"
              >
                  <div class="vue-table__row_name_logo" v-if="props.row.logo_exchange != ''">
                      <picture v-if="isMobile" class="vue-table__row_name_logo">
                          <source
                              :srcset="props.row.images_exchange['mobile']['26x26']['webp'] + ' 1x, '+props.row.images_exchange['mobile']['52x52']['webp'] + ' 2x'"
                              :type="'image/webp'"
                          >
                          <img
                              :src="props.row.images_exchange['mobile']['26x26']['png']"
                              :srcset="props.row.images_exchange['mobile']['52x52']['png'] + ' 2x'"
                              :loading="'lazy'"
                              class="vue-table__row_name_logo" width="26" height="26"
                          />
                      </picture>
                      <picture v-else class="vue-table__row_name_logo">
                          <source

                              :srcset="props.row.images_exchange['desktop']['16x16']['webp'] + ' 1x, '+props.row.images_exchange['desktop']['32x32']['webp'] + ' 2x'"
                              :type="'image/webp'"
                          >
                          <img
                              :src="props.row.images_exchange['desktop']['16x16']['png']"
                              :srcset="props.row.images_exchange['desktop']['32x32']['png'] + ' 2x'"
                              :loading="'lazy'"
                              class="vue-table__row_name_logo" width="16" height="16"
                          />
                      </picture>
                  </div>
                  <div
                      v-else
                      class="vue-table__row_name_logo"
                  ></div>
                <div class="vue-table__row_wrapper">
                  <div
                  class="vue-table__row_name_name"
                  v-if="!isMobile"
                  >
                    {{ props.row.exchange_name }}
                  </div>
                  <div
                  class="vue-table__row_name_name"
                  v-if="isMobile"
                  >
                    {{ props.row.exchange_name | truncate(13, '...') }}
                  </div>
                  <div
                  class="vue-table__row_wrapper"
                  v-if="isMobile"
                  >
                    <div
                    class="vue-table__row_name_code vue-table__row_name_pairs-count"
                    >
                      {{ props.row.pairs_count }}
                      <div>{{ table_code | truncate(5, '...') }}</div>
                      pairs
                    </div>
                  </div>
                </div>
              </a>
              <a
              class="vue-table__row_name"
              :href="table_language != 'en' ? '/' + table_language + '/' + table_section + '/' + props.row.exchange_slug : '/' + table_section + '/' + props.row.exchange_slug"
              v-if="table_section == 'currencyItem_tabTwo'"
              >

                  <picture v-if="isMobile" class="vue-table__row_name_logo">
                      <source
                          :srcset="props.row.images_from['mobile']['26x26']['webp'] + ' 1x, '+props.row.images_from['mobile']['52x52']['webp'] + ' 2x'"
                          :type="'image/webp'"
                      >
                      <img
                          :src="props.row.images_from['mobile']['26x26']['png']"
                          :srcset="props.row.images_from['mobile']['52x52']['png'] + ' 2x'"
                          :loading="'lazy'"
                          class="vue-table__row_name_logo" width="26" height="26"
                      />
                  </picture>
                  <picture v-else class="vue-table__row_name_logo">
                      <source

                          :srcset="props.row.images_exchange['desktop']['16x16']['webp'] + ' 1x, '+props.row.images_exchange['desktop']['32x32']['webp'] + ' 2x'"
                          :type="'image/webp'"
                      >
                      <img
                          :src="props.row.images_exchange['desktop']['16x16']['png']"
                          :srcset="props.row.images_exchange['desktop']['32x32']['png'] + ' 2x'"
                          :loading="'lazy'"
                          class="vue-table__row_name_logo" width="16" height="16"
                      />
                  </picture>
                <div class="vue-table__row_wrapper">
                  <div
                  class="vue-table__row_name_name"
                  v-if="!isMobile"
                  >
                    {{ props.row.exchange_name }}
                  </div>
                  <div
                  class="vue-table__row_name_name"
                  v-if="isMobile"
                  >
                    {{ props.row.symbol }}
                  </div>
                  <div
                  class="vue-table__row_wrapper"
                  v-if="isMobile"
                  >
                    <div
                    class="vue-table__row_name_code"
                    v-if="!isMobile"
                    >
                      {{ props.row.exchange_code }}
                    </div>
                    <div
                    class="vue-table__row_name_code"
                    v-if="isMobile"
                    >
                      {{ props.row.exchange_name | truncate(13, '...') }}
                    </div>
                  </div>
                </div>
              </a>
          </div>
      </template>

      <template slot="price_usd" slot-scope="props">
          <template v-if="table_section == 'currencyItem_tabTwo' ">
            {{ props.row.price_usd }}
            <i class="fas fa-dollar-sign"></i>
          </template>
          <div v-else class="vue-table__row_price">
              <div
              class="vue-table__row_wrapper vue-table__row_price-usd-table__main"
              v-if="table_section != 'currencyItem_tabOne'"
              >
                <div class="vue-table__wrapper__row">
                  <div
                  v-if="mobWallet != 'BTC' && table_section != 'currencyItem_tabOne' && table_code != 'btc'"
                  >
                    {{ props.row.price_usd }}
                  </div>
                  <i
                  class="fas"
                  :class="'fa-' + table_currency.icon"
                  v-if="mobWallet != 'BTC' && table_section != 'currencyItem_tabOne' && table_code != 'btc'"
                  ></i>
                  <div
                  v-if="mobWallet == 'BTC' && table_section != 'currencyItem_tabOne' && table_code != 'btc'"
                  >
                    &nbsp;BTC
                  </div>
                </div>
                <div
                class="vue-table__wrapper__row"
                v-if="isMobile"
                >
                  <div
                  class="vue-table__row_price__info"
                  @click="priceUsdFilter()"
                  >
                    <div class="vue-table__row_price__info__title">
                      {{ priceUsdFilterHeading() }}
                    </div>

                    <i
                    class="fas"
                    :class="'fa-' + table_currency.icon"
                    v-if="price_usd_filter != 'total_supply' && mobWallet != 'BTC' && table_section != 'currencyItem_tabOne' && table_code != 'btc'"
                    ></i>

                    <!-- tableOne -->
                      <i
                      class="fas fa-dollar-sign"
                      v-if="price_usd_filter != 'total_supply' && mobWallet != 'BTC' && table_section == 'currencyItem_tabOne' && table_code != 'btc'"
                      ></i>

                        <!-- bitcoin -->
                          <i
                          class="fas fa-dollar-sign"
                          v-if="price_usd_filter != 'total_supply' && mobWallet != 'EUR' && table_section == 'currencyItem_tabOne' && table_code == 'btc'"
                          ></i>
                          <i
                          class="fas fa-euro-sign"
                          v-if="price_usd_filter != 'total_supply' && mobWallet == 'EUR' && table_section == 'currencyItem_tabOne' && table_code == 'btc'"
                          ></i>
                        <!-- /bitcoin -->
                    <template v-if=" table_section == 'currencies' ">
                      {{ priceUsdReduction(props.row[price_usd_filter], price_usd_filter, true) }}
                    </template>
                    <template v-else>
                      {{ priceUsdReduction(props.row[price_usd_filter], price_usd_filter) }}
                    </template>

                      <div
                      v-if="price_usd_filter != 'total_supply' && mobWallet == 'BTC' && table_section == 'currencyItem_tabOne' && table_code != 'btc'"
                      >
                        &nbsp;BTC
                      </div>
                    <!-- /tableOne -->

                    <div
                    v-if="price_usd_filter != 'total_supply' && mobWallet == 'BTC' && table_section != 'currencyItem_tabOne' && table_code != 'btc'"
                    >
                      &nbsp;BTC
                    </div>
                  </div>
                </div>
              </div>
            <div
            class="vue-table__row_wrapper vue-table__row_price-usd-table__detail"
            v-if="!isMobile && table_section == 'currencyItem_tabOne'"
            >
              {{ parseFloat(props.row.price_usd) > 0 ? props.row.price_usd : '-' }}
            </div>
            <div
            class="vue-table__row_wrapper vue-table__row_price-usd-table__detail"
            v-if="isMobile && table_section == 'currencyItem_tabOne'"
            >
              <div
              class="vue-table__row_price-usd__items"
              v-if="table_code != 'btc'"
              >
                <div
                class="vue-table__row_price-usd__item"
                v-if="Number(props.row.price_usd.replace(/\s/g, '')) > 0"
                >
                  <div class="vue-table__row_price-usd__name">
                    {{ table_code | truncate(5, '...') }}/USD
                  </div>
                  <div class="vue-table__row_price-usd__content">
                    {{ priceUsdReduction(props.row.price_usd) }}
                  </div>
                </div>
                <div
                class="vue-table__row_price-usd__item"
                >
                  <div class="vue-table__row_price-usd__name">
                   {{ table_code | truncate(5, '...') }}/BTC
                  </div>
                  <div class="vue-table__row_price-usd__content">
                    {{ parseFloat(props.row.btc) > 0 ? props.row.btc : '-' }}
                  </div>
                </div>
              </div>

              <div
              class="vue-table__row_price-usd__items"
              v-if="table_code == 'btc'"
              >
                <div
                class="vue-table__row_price-usd__item"
                v-if="Number(props.row.price_usd.replace(/\s/g, '')) > 0"
                >
                  <div class="vue-table__row_price-usd__name">
                    {{ table_code | truncate(5, '...') }}/USD
                  </div>
                  <div class="vue-table__row_price-usd__content">
                      {{ props.row.price_usd }}
                  </div>
                </div>

                <div
                class="vue-table__row_price-usd__item"
                v-if="Number(props.row.price_euro.replace(/\s/g, '')) > 0"
                >
                  <div class="vue-table__row_price-usd__name">
                    {{ table_code | truncate(5, '...') }}/EUR
                  </div>
                  <div class="vue-table__row_price-usd__content">
                      {{ props.row.price_euro }}
                  </div>
                </div>
              </div>
            </div>
          </div>
      </template>

      <template slot="years" slot-scope="props">
          {{ props.row.years + 1 }}
      </template>

      <template slot="price_euro" slot-scope="props">
        <div
        class="vue-table__row_volume_24_usd_delta"
        >
          {{ parseFloat(props.row.price_euro) > 0 ? props.row.price_euro : '-' }}
        </div>
      </template>

      <template slot="price_btc" slot-scope="props">
        <div
        class="vue-table__row_volume_24_usd_delta"
        >
          {{ parseFloat(props.row.price_btc) > 0 ? props.row.price_btc : '-' }}
        </div>
      </template>

      <template
      slot="price_usd_delta"
      slot-scope="props"
      >
          <div
          class="vue-table__row_price-delta"
          :class="props.row.price_usd_delta > 0 ? 'vue-table__row_int_plus' : props.row.price_usd_delta < 0 ? 'vue-table__row_int_minus' : ''"
          >
            {{ props.row.price_usd_delta }}%
          </div>
      </template>

      <template slot="price_graph" slot-scope="props">
        <div>
          <img
          class="vue-table__row_price-graph"
          :src="props.row.price_graph"
          style="max-width: 100px; width: auto; margin: 0 auto; display: block;"
          alt=""
          v-if="!isMobile"
          width="100"
          height="56"
          >
          <img
          class="vue-table__row_price-graph"
          :src="props.row.price_graph"
          style="max-width: 85px; width: auto; max-height: 28px; margin: 0 auto; display: block;"
          alt=""
          v-if="isMobile"
          width="50"
          height="28"
          >
        </div>
      </template>

      <template slot="market_cap_usd" slot-scope="props">
          <div class="vue-table__row_capital">
            <div class="vue-table__row_wrapper__width">
              <div class="vue-table__row_wrapper">
                <div class="vue-table__row_capital__market_cap-usd">
                  {{ props.row.market_cap_usd }}
                  <i
                  class="fas"
                  :class="'fa-' + table_currency.icon"
                  ></i>
                </div>
                <div
                class="vue-table__row_capital__market_cap-usd-delta"
                >
                  {{ parseFloat(props.row.market_share) > 0 ? props.row.market_share : '< 0.01' }}%
                </div>
              </div>
              <div class="vue-table__row_capital__market_cap-usd-delta" :class="props.row.market_cap_usd_delta > 0 ? 'vue-table__row_int_plus' : props.row.market_cap_usd_delta < 0 ? 'vue-table__row_int_minus' : ''">{{ props.row.market_cap_usd_delta }}%</div>
            </div>
          </div>
      </template>

      <template slot="available_supply" slot-scope="props">
          <div class="vue-table__row_available-supply">
            <span class="table__icons">
							<span
              v-if="props.row.b_mining"
              :tooltip="table_language == 'en' ? 'Mining is available' : 'Возможен майнинг'"
              flow="down"
              >
								<svg class="i i-pick-tool icon--fill-gray table__icons table__icons--tooltip">
                  <use
                  xlink:href="/themes/finliners/assets/src/svg/sprites/sprite.svg#i-pick-tool"
                  ></use>
                </svg>
              </span>
              <span
              v-if="props.row.b_token"
              :tooltip="table_language == 'en' ? 'Token' : 'Токен'"
              flow="down"
              >
                <svg class="i i-coin icon--fill-gray table__icons table__icons--tooltip">
                <use
                xlink:href="/themes/finliners/assets/src/svg/sprites/sprite.svg#i-coin"
                ></use>
                </svg>
              </span>
            </span>
            <div class="vue-table__row_available-supply_available-supply">{{ props.row.available_supply }}</div>
          </div>
      </template>

      <template slot="volume_24_usd" slot-scope="props">
          <div class="vue-table__row_volume-24-usd" @click="exchangesTdEdit()">
            <div
            class="vue-table__row_wrapper"
            v-if="table_section == 'exchanges'"
            >
              <div class="vue-table__wrapper__row vue-table__row_volume-24-usd__star__row">
                <span v-if="props.row.is_isolated" class="vue-table__row_volume-24-usd__star">*</span>
                <i
                class="fas"
                :class="'fa-' + table_currency.icon"
                v-if="mobWallet != 'BTC' && table_section == 'exchanges'"
                ></i>
                <div
                v-if="mobWallet != 'BTC' && table_section == 'exchanges'"
                >
                  {{  priceUsdReduction(props.row.volume_24_usd)  }}
                </div>
              </div>
              <div
              class="vue-table__wrapper__row"
              v-if="isMobile"
              >
                <div
                class="vue-table__row_price__info"
                >
                  <div
                  v-if="mobWallet != 'BTC'"
                  >
                    <template v-if="!exchangesTdEditVar">
                      <div> {{ table_language == 'en' ? 'Share' : 'Доля' }} {{ props.row.market_share }}%</div>
                    </template>
                    <template v-else>
                      <div> {{ table_language == 'en' ? 'Pairs' : 'Пары' }} {{ props.row.pairs_count }}</div>
                    </template>
                  </div>
                </div>
              </div>
            </div>


            <div
            class="vue-table__row_volume-24-usd_volume-24-usd vue-table__row_wrapper"
            v-if="table_section != 'exchanges'"
            >
              <div class="vue-table__row_volume-24-usd__star__row">
                <span v-if="props.row.is_isolated" class="vue-table__row_volume-24-usd__star">*</span>

                {{ props.row.volume_24_usd }}
                <i
                class="fas"
                :class="'fa-' + table_currency.icon"
                ></i>
              </div>
              <div
              class="vue-table__row_volume-24-usd_volume-24-usd__market-share vue-table__row_market_share"
              v-if="table_section == 'currencyItem_tabOne'"
              >
                {{ parseFloat(props.row.market_share) > 0 ? props.row.market_share : '< 0.01' }}%
              </div>
            </div>
          </div>
      </template>

      <template slot="volume_24_usd_delta" slot-scope="props">
          <div
          class="vue-table__row_volume_24_usd_delta"
          :class="props.row.volume_24_usd_delta > 0 ? 'vue-table__row_int_plus' : props.row.volume_24_usd_delta < 0 ? 'vue-table__row_int_minus' : ''"
          >
            {{ props.row.volume_24_usd_delta }}%
          </div>
      </template>

      <template slot="currencies" slot-scope="props">
            {{ props.row.currencies.length }}
      </template>

      <template slot="platforms" slot-scope="props">
            <div class="table__text-column">
                <img v-for="platform in props.row.platforms" :src="platform.img_src" class="table__logo table__logo--big" width="16" height="16">
            </div>
      </template>

      <template slot="has_2fa" slot-scope="props">
        <template v-if="props.row.has_2fa == '1' ">
					<svg class="i i-done-tick icon--fill-success table__icons" viewBox="0 0 490.434 490.433">
            <path d="M472.003 58.36l-13.132-11.282c-21.798-18.732-54.554-16.644-73.799 4.697L165.39 295.359l-66.312-57.112c-21.775-18.753-54.536-16.707-73.804 4.611l-11.611 12.848a52.934 52.934 0 00-13.595 38.18 52.938 52.938 0 0017.402 36.6l121.553 111.311a52.936 52.936 0 0076.355-4.057l262.245-304.71a52.915 52.915 0 0012.661-38.496 52.92 52.92 0 00-18.281-36.174z"></path>
          </svg>
          <span class="table--transform-normal">{{ table_language == 'en' ? 'Yes' : 'Да' }}</span>
        </template>
        <template v-else>
          <svg class="i i-cancel icon--fill-danger table__icons" viewBox="0 0 21.9 21.9">
            <path d="M14.1 11.3c-.2-.2-.2-.5 0-.7l7.5-7.5c.2-.2.3-.5.3-.7s-.1-.5-.3-.7L20.2.3c-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3l-7.5 7.5c-.2.2-.5.2-.7 0L3.1.3C2.9.1 2.6 0 2.4 0s-.5.1-.7.3L.3 1.7c-.2.2-.3.5-.3.7s.1.5.3.7l7.5 7.5c.2.2.2.5 0 .7L.3 18.8c-.2.2-.3.5-.3.7s.1.5.3.7l1.4 1.4c.2.2.5.3.7.3s.5-.1.7-.3l7.5-7.5c.2-.2.5-.2.7 0l7.5 7.5c.2.2.5.3.7.3s.5-.1.7-.3l1.4-1.4c.2-.2.3-.5.3-.7s-.1-.5-.3-.7l-7.5-7.5z"></path>
          </svg>
          <span class="table--transform-normal">{{ table_language == 'en' ? 'No' : 'Нет' }}</span>
        </template>
      </template>

      <template slot="is_opensource" slot-scope="props">
        <template v-if="props.row.is_opensource == '1' ">
					<svg class="i i-done-tick icon--fill-success table__icons" viewBox="0 0 490.434 490.433">
            <path d="M472.003 58.36l-13.132-11.282c-21.798-18.732-54.554-16.644-73.799 4.697L165.39 295.359l-66.312-57.112c-21.775-18.753-54.536-16.707-73.804 4.611l-11.611 12.848a52.934 52.934 0 00-13.595 38.18 52.938 52.938 0 0017.402 36.6l121.553 111.311a52.936 52.936 0 0076.355-4.057l262.245-304.71a52.915 52.915 0 0012.661-38.496 52.92 52.92 0 00-18.281-36.174z"></path>
          </svg>
          <span class="table--transform-normal">{{ table_language == 'en' ? 'Yes' : 'Да' }}</span>
        </template>
        <template v-else>
          <svg class="i i-cancel icon--fill-danger table__icons" viewBox="0 0 21.9 21.9">
            <path d="M14.1 11.3c-.2-.2-.2-.5 0-.7l7.5-7.5c.2-.2.3-.5.3-.7s-.1-.5-.3-.7L20.2.3c-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3l-7.5 7.5c-.2.2-.5.2-.7 0L3.1.3C2.9.1 2.6 0 2.4 0s-.5.1-.7.3L.3 1.7c-.2.2-.3.5-.3.7s.1.5.3.7l7.5 7.5c.2.2.2.5 0 .7L.3 18.8c-.2.2-.3.5-.3.7s.1.5.3.7l1.4 1.4c.2.2.5.3.7.3s.5-.1.7-.3l7.5-7.5c.2-.2.5-.2.7 0l7.5 7.5c.2.2.5.3.7.3s.5-.1.7-.3l1.4-1.4c.2-.2.3-.5.3-.7s-.1-.5-.3-.7l-7.5-7.5z"></path>
          </svg>
          <span class="table--transform-normal">{{ table_language == 'en' ? 'No' : 'Нет' }}</span>
        </template>
      </template>

      <template slot="private_key" slot-scope="props">
        <template v-if="props.row.private_key == '1' ">
          <svg class="i i-lock icon--fill-success table__icons" viewBox="0 0 401.998 401.998">
            <path d="M357.45 190.721c-5.331-5.33-11.8-7.993-19.417-7.993h-9.131v-54.821c0-35.022-12.559-65.093-37.685-90.218C266.093 12.563 236.025 0 200.998 0c-35.026 0-65.1 12.563-90.222 37.688-25.126 25.126-37.685 55.196-37.685 90.219v54.821h-9.135c-7.611 0-14.084 2.663-19.414 7.993-5.33 5.326-7.994 11.799-7.994 19.417V374.59c0 7.611 2.665 14.086 7.994 19.417 5.33 5.325 11.803 7.991 19.414 7.991H338.04c7.617 0 14.085-2.663 19.417-7.991 5.325-5.331 7.994-11.806 7.994-19.417V210.135c.004-7.612-2.669-14.084-8.001-19.414zm-83.363-7.993H127.909v-54.821c0-20.175 7.139-37.402 21.414-51.675 14.277-14.275 31.501-21.411 51.678-21.411 20.179 0 37.399 7.135 51.677 21.411 14.271 14.272 21.409 31.5 21.409 51.675v54.821z"></path>
          </svg>
          <span  class="table--transform-normal">{{ table_language == 'en' ? props.row.private_key_text : 'Хранится на устройстве пользователя' }}</span>
        </template>
        <template v-else-if="props.row.private_key == '2' ">
          <svg class="i i-lock icon--fill-danger table__icons" viewBox="0 0 401.998 401.998">
            <path d="M357.45 190.721c-5.331-5.33-11.8-7.993-19.417-7.993h-9.131v-54.821c0-35.022-12.559-65.093-37.685-90.218C266.093 12.563 236.025 0 200.998 0c-35.026 0-65.1 12.563-90.222 37.688-25.126 25.126-37.685 55.196-37.685 90.219v54.821h-9.135c-7.611 0-14.084 2.663-19.414 7.993-5.33 5.326-7.994 11.799-7.994 19.417V374.59c0 7.611 2.665 14.086 7.994 19.417 5.33 5.325 11.803 7.991 19.414 7.991H338.04c7.617 0 14.085-2.663 19.417-7.991 5.325-5.331 7.994-11.806 7.994-19.417V210.135c.004-7.612-2.669-14.084-8.001-19.414zm-83.363-7.993H127.909v-54.821c0-20.175 7.139-37.402 21.414-51.675 14.277-14.275 31.501-21.411 51.678-21.411 20.179 0 37.399 7.135 51.677 21.411 14.271 14.272 21.409 31.5 21.409 51.675v54.821z"></path>
          </svg>
          <span  class="table--transform-normal">{{ table_language == 'en' ? props.row.private_key_text : 'Хранится на сервере, незашифрован' }}</span>
        </template>
        <template v-else>
          <svg class="i i-lock icon--fill-primary table__icons" viewBox="0 0 401.998 401.998">
            <path d="M357.45 190.721c-5.331-5.33-11.8-7.993-19.417-7.993h-9.131v-54.821c0-35.022-12.559-65.093-37.685-90.218C266.093 12.563 236.025 0 200.998 0c-35.026 0-65.1 12.563-90.222 37.688-25.126 25.126-37.685 55.196-37.685 90.219v54.821h-9.135c-7.611 0-14.084 2.663-19.414 7.993-5.33 5.326-7.994 11.799-7.994 19.417V374.59c0 7.611 2.665 14.086 7.994 19.417 5.33 5.325 11.803 7.991 19.414 7.991H338.04c7.617 0 14.085-2.663 19.417-7.991 5.325-5.331 7.994-11.806 7.994-19.417V210.135c.004-7.612-2.669-14.084-8.001-19.414zm-83.363-7.993H127.909v-54.821c0-20.175 7.139-37.402 21.414-51.675 14.277-14.275 31.501-21.411 51.678-21.411 20.179 0 37.399 7.135 51.677 21.411 14.271 14.272 21.409 31.5 21.409 51.675v54.821z"></path>
          </svg>
          <span  class="table--transform-normal">{{ table_language == 'en' ? props.row.private_key_text : 'Хранится на сервере, зашифрован' }}</span>
        </template>
      </template>

      <template slot="volume_24" slot-scope="props">
          <div
          class="vue-table__row_volume_24_usd_delta"
          >
            <div class="vue-table__row_volume_24__wrapper">
              <div
              class="vue-table__row_volume_24"
              v-if="!isMobile && table_section == 'currencyItem_tabTwo'"
              >
                {{ props.row.volume_24 }}&nbsp;{{ props.row.from_code }}
              </div>
              <div
              class="vue-table__row_volume_24"
              v-if="!isMobile && table_section != 'currencyItem_tabTwo'"
              >
                <!--{{ props.row.volume_24 }}&nbsp;{{ table_code }}-->
                {{ props.row.volume_24 }}&nbsp;{{ props.row.from_code }}
              </div>
              <div
              class="vue-table__row_volume_24"
              v-if="isMobile && mobWallet != 'VOL'"
              >
                <i
                class="fas"
                :class="'fa-' + table_currency.icon"
                ></i>
                <template v-if="table_section == 'exchangeItem' && isMobile">
                  <span class="row_no_active">
                    {{ props.row.volume_24 }}
                    <div>{{ props.row.from_code }}</div>
                  </span>
                  <span class="row_active">
                    {{ props.row.volume_24_usd }}
                    <div>USD</div>
                  </span>
                </template>
                <template v-else>{{ props.row.volume_24 }}</template>
              </div>
              <div
              class="vue-table__row_volume_24"
              v-if="isMobile && mobWallet == 'VOL'"
              >
                {{ props.row.volume_24 }}
                <div>{{ props.row.from_code }}</div>
              </div>
            </div>
            <div
            class="vue-table__row_volume_24__wrapper"
            v-if="isMobile"
            >
              <div
              class="vue-table__row_market_share"
              >
                {{ parseFloat(props.row.market_share) > 0 ? props.row.market_share : '< 0.01' }}%
              </div>
            </div>
          </div>
      </template>

      <template slot="price" slot-scope="props">
          <div
          class="vue-table__row_volume_24_usd_delta vue-table__row_price"
          >
            <template v-if="isMobile">
              <span class="row_no_active">
                {{ props.row.price }}
                <div>{{ props.row.to_code }}</div>
              </span>
              <span class="row_active">
                {{ props.row.price_usd }}
                <div>USD</div>
              </span>
            </template>
            <template v-else>{{ props.row.price }}</template>
          </div>
      </template>

      <template slot="is_new" slot-scope="props">
          <div class="vue-table__row_volume_24_usd_delta vue-table__row_is_new">
            <div v-if="props.row.is_new" class="vue-table__row_is_new__block green">
              <div class="vue-table__row_is_new__trip">
                <template v-if="table_language == 'en'">The last update at</template>
                <template v-else>Последнее обновление</template>
                <span>{{ getFromNow(props.row.fetched_at) }}</span>
              </div>
            </div>
            <div v-else class="vue-table__row_is_new__block red">
              <div class="vue-table__row_is_new__trip">
                <template v-if="table_language == 'en'">The last update at</template>
                <template v-else>Последнее обновление</template>
                <span>{{ getFromNow(props.row.fetched_at) }}</span>
              </div>
            </div>
          </div>
      </template>

      <template slot="symbol" slot-scope="props">
          <div
          class="vue-table__row_volume_24_usd_delta vue-table__row_symbol"
          >
            <div
            v-if="!isMobile || table_section == 'exchangeItem'"
            >
                <picture v-if="isMobile" class="vue-table__row_name_logo">
                    <source
                        :srcset="props.row.images_from['mobile']['26x26']['webp'] + ' 1x, '+props.row.images_from['mobile']['52x52']['webp'] + ' 2x'"
                        :type="'image/webp'"
                    >
                    <img
                        :src="props.row.images_from['mobile']['26x26']['png']"
                        :srcset="props.row.images_from['mobile']['52x52']['png'] + ' 2x'"
                        :loading="'lazy'"
                        class="vue-table__row_name_logo" width="16" height="16"
                    />
                </picture>
                <picture v-else class="vue-table__row_name_logo">
                    <source

                        :srcset="props.row.images_from['desktop']['16x16']['webp'] + ' 1x, '+props.row.images_from['desktop']['32x32']['webp'] + ' 2x'"
                        :type="'image/webp'"
                    >
                    <img
                        :src="props.row.images_from['desktop']['16x16']['png']"
                        :srcset="props.row.images_from['desktop']['32x32']['png'] + ' 2x'"
                        :loading="'lazy'"
                        class="vue-table__row_name_logo" width="16" height="16"
                    />
                </picture>
            </div>
            <!--вывод в парах мобильной версии-->
            <div v-if="isMobile" class="vue-table__row_symbol_mobile">
              <div>{{ props.row.symbol }}</div>

              <div class="vue-table__row_symbol_mobile_row">
                <!--кружок-->
                <div class="vue-table__row_volume_24_usd_delta vue-table__row_is_new">
                  <div v-if="props.row.is_new" class="vue-table__row_is_new__block green">
                    <div class="vue-table__row_is_new__trip">
                      <template v-if="table_language == 'en'">The last update at</template>
                      <template v-else>Последнее обновление</template>
                      <span>{{ getFromNow(props.row.fetched_at) }}</span>
                    </div>
                  </div>
                  <div v-else class="vue-table__row_is_new__block red">
                    <div class="vue-table__row_is_new__trip">
                      <template v-if="table_language == 'en'">The last update at</template>
                      <template v-else>Последнее обновление</template>
                      <span>{{ getFromNow(props.row.fetched_at) }}</span>
                    </div>
                  </div>
                </div>
                <!--кружок-->
                <!--доля-->
                <div
                class="vue-table__row_market_share"
                >
                  {{ table_language == 'en' > 0 ? 'Share' : 'Доля' }} {{ parseFloat(props.row.market_share) > 0 ? props.row.market_share : '< 0.01' }}%
                </div>
                <!--доля-->
              </div>
            </div>
            <!--вывод в парах мобильной версии-->
            <template v-else>{{ props.row.symbol }}</template>
          </div>
      </template>

      <template slot="market_share" slot-scope="props">
          <div
          class="vue-table__row_volume_24_usd_delta"
          >
            {{ parseFloat(props.row.market_share) > 0 ? props.row.market_share : '< 0.01' }}%
          </div>
      </template>
    </v-client-table>
    <!--Pagination-->
    <!--<div v-if="table_per_page" class="order-10 flex flex-between mb-20 mt-20 data__flexbar">
      <div class="data__actions">
          <div v-if="paginationData && paginationData.prev" class="toolbar__button toolbar__button--prev" style="display: flex;" @click="onPagination('prev')">
            <svg class="i i-arrow" viewBox="0 0 123.97 123.97">
              <path d="M51.802 96.062c2.801 2.801 6.5 4.2 10.2 4.2s7.4-1.399 10.2-4.2l47.3-47.3c5.5-5.5 6.101-14.6.8-20.3-5.6-6.1-15.1-6.3-20.899-.5l-30.4 30.3a9.959 9.959 0 01-14.1 0l-30.3-30.3c-5.801-5.8-15.301-5.7-20.9.5-5.3 5.7-4.8 14.8.8 20.3l47.299 47.3z"/>
            </svg>
            <span>Prev</span>
          </div>
          <div v-if="paginationData && paginationData.next" href="#" class="toolbar__button toolbar__button--next" style="display: flex;" @click="onPagination('next')">
            <span>Next</span>
            <svg class="i i-arrow" viewBox="0 0 123.97 123.97">
              <path d="M51.802 96.062c2.801 2.801 6.5 4.2 10.2 4.2s7.4-1.399 10.2-4.2l47.3-47.3c5.5-5.5 6.101-14.6.8-20.3-5.6-6.1-15.1-6.3-20.899-.5l-30.4 30.3a9.959 9.959 0 01-14.1 0l-30.3-30.3c-5.801-5.8-15.301-5.7-20.9.5-5.3 5.7-4.8 14.8.8 20.3l47.299 47.3z"/>
            </svg>
          </div>
      </div>
    </div>-->
    <!--Pagination-->
  </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import {ServerTable, ClientTable, Event} from 'vue-tables-2';
import moment from "moment-timezone";

Vue.use(ServerTable, options, false, template);
Vue.use(Event);

let options = {};
let useVuex = false;
let theme = "bootstrap4";
let template = "default";
Vue.use(ClientTable, options, useVuex, theme, template);

var mixinDetictingMobile = {
  methods: {
    checkMobile: function() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  }
}

export default {
  props: [
      'table_per_page',
      'table_currency',
      'table_language',
      'table_section',
      'table_src', 'table_filter_options_src', 'table_columns', 'table_columns_mob', 'table_code', 'table_main', 'table_per_page_mob' ],
  mixins: [mixinDetictingMobile],
  data() {
    return {
      columns: [],
      tableData: [],
      coinsCount: 0,
      tokensCount: 0,
      options: {
        headings: {},
        texts: {
          noResults:'No matching records'
        },
        perPage: 20,
        customFilters: [
            {
                name: 'coins',
                callback: function(row, query) {
                    return row.b_mining == query;
                }
            },
            {
                name: 'tokens',
                callback: function(row, query) {
                    return row.b_token == query;
                }
            },
            {
                name: 'from_code',
                callback: function(row, query) {
                    return row.from_code == query;
                }
            },
            {
                name: 'to_code',
                callback: function(row, query) {
                    return row.to_code == query;
                }
            },
            {
                name: 'currency_ids',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.currency_ids.includes(param)) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'currencies',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.currencies.includes(param)) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'platforms',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {
                        for (var platform of row.platforms) {
                            if(platform.id == param) {
                                found = true;
                                break;
                            }
                        }
                    }

                    return found;
                }
            },
            {
                name: 'private_key',
                callback: function(row, params) {
                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.private_key == param) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'language_wallets',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.languages.includes(param)) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'functionality_wallets',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.functionality.includes(param)) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'has_2fa',
                callback: function(row, params) {
                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.has_2fa == param) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'has_multisignature',
                callback: function(row, params) {
                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.has_multisignature == param) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'is_opensource',
                callback: function(row, params) {
                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.is_opensource == param) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'has_newbie_alert',
                callback: function(row, params) {
                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.has_newbie_alert == param) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'fiat_ids',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.fiat_ids.includes(param)) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'payment_ids',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.payment_ids.includes(param)) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'country_id',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.country_id == param) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'language_ids',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if(row.language_ids.includes(param)) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            },
            {
                name: 'functionality',
                callback: function(row, params) {

                    if(params.length <= 0) {

                        return true;
                    }

                    let found = false;

                    for (const param of params) {

                        if((param == 'is_decentralized' && row.is_decentralized) || (param == 'is_margin_trading' && row.is_margin_trading) || (param == 'is_derivatives' && row.is_derivatives)) {

                            found = true;
                            break;
                        }
                    }

                    return found;
                }
            }],
        customSorting: {
          market_cap_usd: function (ascending) {

              return function (a, b) {

                  var lastA = parseFloat( a.market_cap_usd.split(' ').join('') );
                  var lastB = parseFloat( b.market_cap_usd.split(' ').join('') );

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          volume_24: function (ascending) {

              return function (a, b) {

                  var lastA = parseFloat( String(a.volume_24).replace(/ /g, '') );
                  var lastB = parseFloat( String(b.volume_24).replace(/ /g, '') );

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          volume_24_usd: function (ascending) {

              return function (a, b) {

                  var lastA = parseFloat( a.volume_24_usd.split(' ').join('') );
                  var lastB = parseFloat( b.volume_24_usd.split(' ').join('') );

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          volume_24_usd_delta: function (ascending) {

              return function (a, b) {

                  var lastA = parseFloat( a.volume_24_usd_delta.split(' ').join('') );
                  var lastB = parseFloat( b.volume_24_usd_delta.split(' ').join('') );

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          price: function (ascending) {

              return function (a, b) {

                  var lastA = parseFloat( a.price.split(' ').join('') );
                  var lastB = parseFloat( b.price.split(' ').join('') );

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          price_usd: function (ascending) {

              return function (a, b) {
                  if (typeof a.price_usd != 'number' && typeof b.price_usd != 'number') {
                    var lastA = parseFloat( a.price_usd.split(' ').join('') );
                    var lastB = parseFloat( b.price_usd.split(' ').join('') );
                  } else {
                    var lastA = a.price_usd;
                    var lastB = b.price_usd;
                  }

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          price_usd_delta: function (ascending) {

              return function (a, b) {

                  var lastA = parseFloat( a.price_usd_delta.split(' ').join('') );
                  var lastB = parseFloat( b.price_usd_delta.split(' ').join('') );

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          available_supply: function (ascending) {

              return function (a, b) {

                  var lastA = parseFloat( a.available_supply.split(' ').join('') );
                  var lastB = parseFloat( b.available_supply.split(' ').join('') );

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          total_supply: function (ascending) {

              return function (a, b) {

                  var lastA = parseFloat( a.total_supply.split(' ').join('') );
                  var lastB = parseFloat( b.total_supply.split(' ').join('') );

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          market_share: function (ascending) {

              return function (a, b) {
                  if (typeof a.market_share != 'number' && typeof b.market_share != 'number') {
                    var lastA = parseFloat( a.market_share.split(' ').join('') );
                    var lastB = parseFloat( b.market_share.split(' ').join('') );
                  } else {
                    var lastA = a.market_share;
                    var lastB = b.market_share;
                  }

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          },
          market_position: function (ascending) {

              return function (a, b) {

                  var lastA = parseInt( a.market_position );
                  var lastB = parseInt( b.market_position );

                  if (ascending) {

                    return lastA >= lastB ? 1 : -1;
                  }

                  return lastA <= lastB ? 1 : -1;
              }
          }
        },
        sortable: [],
        filterable: []
      },
      paginationData: null, //массив линков пагинации
      filteredData: null, // сколько записей показывается
      paginationDisable: null, // проверка существования пагинации
      table_size: null,
      price_usd_filtres: null, // межстрочные фильтры
      price_usd_filtres_active: null, // активные межстрочные фильтры
      price_usd_filtres_from: null, // межстрочные фильтры. Динамические зависящие от валюты
      price_usd_filtres_to: null, // межстрочные фильтры. Динамические зависящие от валюты
      price_usd_filter: null, // секция кнопочного фильтра
      price_usd_filter_heading: null, // заголовок кнопочного фильтра
      selected_sort: null, // заголовок сортировки
      selected_sort_section: null, // секция сортировки
      selectedFilter: 'all', // фильтр
      ascending: true, // определение стрелки сортировки
      beforeFilter: null, // прошлый фильтр (нужен для правильной фильтрации)
      isMobile: null, // проверка на веб-агента
      mob_wallets: null, // валюты
      mobWallet: null, // валюта для вывода
      mobPopup: false,  // мобильный попап
      mobPopupName: null, // заголовок попапа
      mobPopupSection: null, // выборка попапа
      mobPopupMethod: null, // метод выборки попапа
      mobHeadings: [], // мобильные сортировки
      mobCrypto: [], // мобильные фильтры
      exchangesFiltresActive: 'all', // активный фильтр биржи
      exchangesFiltres: [], // фильтры по биржам
      exchangesCurrenciesFiltres: [], // фильтры по валюте
      tableReady: false,
      exchangesTdEditVar: false,
      pairs_counter: null,
      //данные для фильтра
      filterCol_currencies: [],
      filterCol_functionality: [],
      filterCol_fiats: [],
      filterCol_pays: [],
      filterCol_countries: [],
      filterCol_languages: [],
      filterCol_wallets_currencies: [],
      filterCol_wallets_functionality: [],
      filterCol_wallets_has_2fa_options: [],
      filterCol_wallets_has_multisignature_options: [],
      filterCol_wallets_has_newbie_alert_options: [],
      filterCol_wallets_is_opensource_options: [],
      filterCol_wallets_languages: [],
      filterCol_wallets_platforms: [],
      filterCol_wallets_private_key_options: [],
      filtersLang: null,

      exchangesCurrenciesIdsFiltred: [],
      exchangesFunctionalityFiltred: [],
      exchangesFiatsIdsFiltred: [],
      exchangesPaymentsIdsFiltred: [],
      exchangesCountriesIdsFiltred: [],
      exchangesLanguagesIdsFiltred: [],

      walletsCurrenciesIdsFiltered: [],
      walletsFunctionalityIdsFiltered: [],
      walletsHas2faOptionsIdsFiltered: [],
      walletsHasMultisignatureOptionsIdsFiltered: [],
      walletsHasNewbieAlertOptionsIdsFiltered: [],
      walletsIsOpensourceOptionsIdsFiltered: [],
      walletsLanguagesIdsFiltered: [],
      walletsPlatformsIdsFiltered: [],
      walletsPrivateKeyOptionsIdsFiltered: [],

      //данные для фильтра
    };
  },
  filters: {
    truncate: function (text, length, clamp) {
      clamp = clamp || '...';
      var node = document.createElement('div');
      node.innerHTML = text;
      var content = node.textContent;
      return content.length > length ? content.slice(0, length) + clamp : content;
    }
  },
  watch: {},
  methods: {
    async tableDataGet() {

      const dataTableAwait = await axios.get(this.table_src).then(async(response) => {

        // фильтр
        if(this.table_section == 'exchanges' && this.table_filter_options_src) {
          const res = await axios.get(this.table_filter_options_src);
          this.filterCol_currencies = res.data.currencies ?? [];
          this.filterCol_functionality = res.data.functionality ?? [];
          this.filterCol_fiats = res.data.fiats ?? [];
          this.filterCol_pays = res.data.payments ?? [];
          this.filterCol_countries = res.data.countries ?? [];
          this.filterCol_languages = res.data.languages ?? [];
        }
        if(this.table_section == 'wallets' && this.table_filter_options_src) {
          const res = await axios.get(this.table_filter_options_src);
          this.filterCol_wallets_currencies = res.data.currencies ?? [];
          this.filterCol_wallets_functionality = res.data.functionality ?? [];
          this.filterCol_wallets_has_2fa_options = res.data.has_2fa_options ?? [];
          this.filterCol_wallets_has_multisignature_options = res.data.has_multisignature_options ?? [];
          this.filterCol_wallets_has_newbie_alert_options = res.data.has_newbie_alert_options ?? [];
          this.filterCol_wallets_is_opensource_options = res.data.is_opensource_options ?? [];
          this.filterCol_wallets_languages = res.data.languages ?? [];
          this.filterCol_wallets_platforms = res.data.platforms ?? [];
          this.filterCol_wallets_private_key_options = res.data.private_key_options ?? [];
        }

        if(response.data) {
          this.columns_count = response.data.data.length;

          if(this.table_main) {
            this.tableData = response.data.data.slice(0, 5);
          }
          else {
            this.tableData = response.data.data;
          }

          if(response.data.links) {
            this.paginationData = response.data.links;
          }

          if (this.table_section == 'currencies') {
            var coinsCounter = this.coinsCount;
            var tokensCounter = this.tokensCount;

            response.data.data.forEach(function(element, i) {
              if (element.b_token == true) {
                tokensCounter++
              } else {
                coinsCounter++
              }
            });

            this.coinsCount = coinsCounter;
            this.tokensCount = tokensCounter;
          }

          if (this.table_section == 'exchangeItem') {
            var userExists = (name, data) => {
              return data.some(function(el) {
                return el.name === name;
              });
            }

            this.tableData.forEach((e_table, i_table) => {
              if (!userExists(e_table.from_code, this.exchangesFiltres) && e_table.from_is_fiat == false) {
                  this.exchangesFiltres.push({
                    name: e_table.from_code,
                    section: 'from_code'
                  });
              }
              if (!userExists(e_table.to_code, this.exchangesFiltres) && e_table.to_is_fiat == false) {
                  this.exchangesFiltres.push({
                    name: e_table.to_code,
                    section: 'to_code'
                  });
              }
              if (!userExists(e_table.from_code, this.exchangesCurrenciesFiltres) && e_table.from_is_fiat == true) {
                  this.exchangesCurrenciesFiltres.push({
                    name: e_table.from_code,
                    section: 'from_code'
                  });
              }
              if (!userExists(e_table.to_code, this.exchangesCurrenciesFiltres) && e_table.to_is_fiat == true) {
                  this.exchangesCurrenciesFiltres.push({
                    name: e_table.to_code,
                    section: 'to_code'
                  });
              }
            });

            this.selected_sort_section = "volume_24_usd";
            if (this.table_language == 'en') {
              this.selected_sort = "Volume USD";
            }
            else {
              this.selected_sort = "Объем USD";
            }
          }

          if (this.table_section == 'currencyItem_tabOne') {
            document.querySelector('.toolbar__stat > span:nth-child(2)').innerHTML = this.tableData.length;
          }

          if (this.table_section == 'currencyItem_tabTwo') {
            document.querySelector('.toolbar__stat > span:nth-child(1)').innerHTML = this.tableData.length;
          }

          if(this.selected_sort_section ||  this.selected_sort) {
            this.sortColumn({ascending:true, column:this.selected_sort_section}, this.selected_sort);
          }
        }
      }).catch(err => {
        if(err.msg) {
          alert('error');
        }
      });
    },
    onPagination(type){
      if(type == 'next' && this.paginationData.next) {
        if(!this.paginationData.next.startsWith('/?page=')) {
          this.table_src =  this.paginationData.next;
        }
        else {
          this.table_src =  window.location.origin + '/api/v1.0/main' + window.location.pathname + this.paginationData.next;
        }
        console.log(this.table_src);
        this.tableDataGet();
      } else if(type == 'prev' && this.paginationData.prev) {
        if(!this.paginationData.prev.startsWith('/?page=')) {
          this.table_src =  this.paginationData.prev;
        }
        else {
          this.table_src =  window.location.origin + '/api/v1.0/main' + window.location.pathname + this.paginationData.prev;
        }
        console.log(this.table_src);
        this.tableDataGet();
      }

    },
    togglePopupData(data, headings) {
      data.forEach((item, index) => {
        if (headings[item] != "undefined") {
          let key = data[index];
          var params = '';

          // параметры для фильтрации
          if (data[index] == 'coins') {
            params = false;
          }
          if (data[index] == 'tokens') {
            params = true;
          }

          data[index] = {
            name: headings[item],
            section: key,
            params: params // для фильтра
          };
        }
      });
    },
    clearFilters(filters, filters_clear) {
      var filters_clear_index = [];
      filters.forEach((item, index) => {
        filters_clear.forEach((e, i) => {
          if (item == e) {
            filters_clear_index.push(index);
          }
        });
      });

      filters_clear_index.reverse();
      filters_clear_index.forEach((item, index) => {
        filters.splice(item, 1);
      })

      if (this.price_usd_filtres_active == 'price_usd_filtres_from') {
        this.price_usd_filtres = filters.concat(this.price_usd_filtres_to.filters);

        this.price_usd_filtres_active = this.price_usd_filtres_to.name;
      } else if (this.price_usd_filtres_active == 'price_usd_filtres_to') {
        this.price_usd_filtres = filters.concat(this.price_usd_filtres_from.filters);

        this.price_usd_filtres_active = this.price_usd_filtres_from.name;
      }

    },
    toggleMobilePopup(name, section, method) {
      this.mobPopupName = name;
      this.mobPopupSection = section;
      this.mobPopupMethod = method;
    },
    filterColumn(filter, params) {
      if (!filter == 'all' && this.isMobile == true || !filter == '' && this.isMobile == true) {
        this.selectedFilter = filter;
      } else if (this.isMobile == false) {
        this.selectedFilter = filter;
      }

      if (!this.selectedFilter == '' && !this.beforeFilter == '' || !this.selectedFilter == 'all' && !this.beforeFilter == 'all') {
        Event.$emit('vue-tables.filter::' + this.beforeFilter, '');
      }

      if (!filter == 'all' || !filter == '') {
        Event.$emit('vue-tables.filter::' + filter, params);
      }

      this.beforeFilter = filter;
    },
    filterExchanges(filter, params) {

      Event.$emit('vue-tables.filter::' + filter, params);
    },
  	sortColumn(filter, filter_name) {
      this.$refs.table.orderByColumn(filter.column, filter);
    	Event.$emit('vue-tables.sorted', filter);
      this.selected_sort = filter_name;
      this.selected_sort_section = filter.column;
    },
    mobWalletChange() {
      var before_price_usd_filter = null;

      if (this.price_usd_filtres != null) {
        for (var i = 0; i < this.price_usd_filtres.length; i++) {
          if (this.price_usd_filtres[i] == this.price_usd_filter) {
            before_price_usd_filter = i;

            break;
          }
        }
      }

      if (this.price_usd_filtres_active == 'price_usd_filtres_from') {
        this.clearFilters(this.price_usd_filtres, this.price_usd_filtres_from.filters);
      } else if (this.price_usd_filtres_active == 'price_usd_filtres_to') {
        this.clearFilters(this.price_usd_filtres, this.price_usd_filtres_to.filters);
      }

      this.priceUsdFilter(before_price_usd_filter);

      for (var i = 0; i < this.mob_wallets.length; i++) {
        if (i == this.mob_wallets.length - 1) {
          this.mobWallet = this.mob_wallets[0];

          break;
        } else if (this.mob_wallets[i] == this.mobWallet) {
          this.mobWallet = this.mob_wallets[i + 1];

          break;
        }
      }
    },
    priceUsdFilter(before_price_usd_filter) {
      if (this.price_usd_filtres != null) {
        for (var i = 0; i < this.price_usd_filtres.length; i++) {
          if (typeof before_price_usd_filter === 'number') {
            this.price_usd_filter = this.price_usd_filtres[before_price_usd_filter]
          } else {
            if (i == this.price_usd_filtres.length - 1) {
              this.price_usd_filter = this.price_usd_filtres[0];

              break;
            } else if (this.price_usd_filtres[i] == this.price_usd_filter) {
              this.price_usd_filter = this.price_usd_filtres[i + 1];

              break;
            }
          }
        }
      }
    },
    priceUsdFilterHeading() {
      let priceFilter = this.price_usd_filter;

      if (priceFilter == 'total_supply') {
        if (this.table_language == 'en') {
          return 'Supplay';
        }
        else {
          return 'Монет';
        }
      } else if (priceFilter == 'volume_24_usd') {
        if (this.table_language == 'en') {
          return 'Vol';
        }
        else {
          return 'Торг';
        }
      } else if (priceFilter == 'market_cap_usd') {
        if (this.table_language == 'en') {
          return 'MCap';
        }
        else {
          return 'Кап';
        }
      }
    },
    priceUsdReduction(price_usd, bn = null, bn2 = null) {

        if (typeof price_usd != 'number') {
          price_usd = price_usd.replace(/\s/g, '');
          price_usd = parseFloat(price_usd);
        }

        var suffix = '';

        function truncateToDecimals(num, dec = 2) {
          const calcDec = Math.pow(10, dec);
          price_usd = Math.trunc(num * calcDec) / calcDec;
        }

        if (Math.floor(price_usd / 1000)) {
          price_usd = price_usd / 1000;
          suffix = ' K';
        }

        if (Math.floor(price_usd / 1000)) {
          price_usd = price_usd / 1000;
          suffix = ' M';
        }

        if (Math.floor(price_usd / 1000) && (bn == true || bn2 == true)) {
          price_usd = price_usd / 1000;
          suffix = ' Bn';
        }

        if (Math.floor(price_usd / 1000) && (bn == true || bn2 == true)) {
          price_usd = price_usd / 1000;
          suffix = ' T';
        }

        truncateToDecimals(price_usd);

        return price_usd.toString() + suffix;
    },
    mobUniqueHeadings(data) {
      var seen = {};
      return data.filter(function(item) {
          return seen.hasOwnProperty(item) ? false : (seen[item] = true);
      });
    },
    showFilter(params) {
      if(params === 'hide') {
        $('.js-filter-hide').hide()
        $('.js-filter-show').show()

        $('.js-filter-wrap').hide()
      }
      else if (params === 'show') {
        $('.js-filter-hide').show()
        $('.js-filter-show').hide()

        $('.js-filter-wrap').show()
      }
      else {
        $('.js-filter-reset').hide();
        $('.filter__field input').prop('checked', false);
        this.options.customFilters.forEach(function (filter) {
           Event.$emit('vue-tables.filter::' + filter.name, '');
        });
      }
    },
    exchangesTdEdit() {
      if(this.exchangesTdEditVar) {
        this.exchangesTdEditVar = false;
      }
      else {
        this.exchangesTdEditVar = true;
      }
    },
    getFromNow(element) {
      return moment(element, 'YYYY-MM-DD hh:mm:ss').tz('UTC', true).fromNow()
    }
  },
  created() {

    // проверка устройства
    if (this.checkMobile()) {
      this.isMobile = true;

      document.body.classList.add('device_mobile');
    } else {
      this.isMobile = false;
    }

    if(parseInt(this.table_per_page_mob) > 0 && this.isMobile == true) {
      this.options.perPage = parseInt(this.table_per_page_mob)
    }
    else if(parseInt(this.table_per_page) > 0) {
      this.options.perPage = parseInt(this.table_per_page)
    }

    if (this.table_language != 'en') {
      this.options.texts.noResults = 'Нет совпадений';
    }

    if (this.table_language != 'en') {
      this.options.texts.filterPlaceholder = 'Поиск';
    }
    else {
      this.options.texts.filterPlaceholder = 'Search';
    }

    if (this.table_section == 'currencies') {
      // массив полей (приходят из DOM-атрибутов)
      if (!this.isMobile) {
        this.columns = this.table_columns;
      } else {
        this.columns = this.table_columns_mob;
      }

      if (this.table_language == 'en') {
        this.options.headings = {
          market_position: '#',
          name: 'Name',
          price_usd: 'Price',
          price_usd_delta: 'Price',
          price_graph: '7 days chart',
          market_cap_usd: 'Capitalization',
          available_supply: 'Available supply',
          volume_24_usd: 'Volume',
          all: 'All',
          coins: 'Coins',
          tokens: 'Tokens',
          total_supply: 'Total Supply'
        }

        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы
          this.mobHeadingsNames = {
            market_position: 'Position',
            name: 'Name',
            price_usd: 'Price',
            price_usd_delta: 'Price 24 hours',
            price_graph: '7 days chart',
            market_cap_usd: 'Capitalization',
            available_supply: 'Available supply',
            volume_24_usd: 'Volume',
            all: 'All',
            coins: 'Coins',
            tokens: 'Tokens',
            total_supply: 'Total Supply'
          }
        }
      } else {
        this.options.headings = {
          market_position: '#',
          name: 'Название',
          price_usd: 'Цена',
          price_usd_delta: 'Цена',
          price_graph: 'График за 7 дней',
          market_cap_usd: 'Капитализация',
          available_supply: 'Доступно денег',
          volume_24_usd: 'Объем',
          all: 'Все',
          coins: 'Монеты',
          tokens: 'Токены'
        };

        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы на русском
          this.mobHeadingsNames = {
            market_position: 'Позиция',
            name: 'Название',
            price_usd: 'Цена',
            price_usd_delta: 'Цена 24 часа',
            price_graph: 'График за 7 дней',
            market_cap_usd: 'Капитализация',
            available_supply: 'Доступно денег',
            volume_24_usd: 'Объем',
            all: 'Все',
            coins: 'Монеты',
            tokens: 'Токены',
            total_supply: 'Общий объем'
          };
        }
      }

      this.options.sortable = ["market_position", "name", "price_usd", "price_usd_delta", "market_cap_usd", "available_supply", "volume_24_usd", "total_supply"];
      //this.options.descOrderColumns = ["market_position", "name", "price_usd", "price_usd_delta", "market_cap_usd", "available_supply", "volume_24_usd", "total_supply"];
      this.options.filterable = ["code", "name"];

      if (this.isMobile) {
        this.mob_wallets = ['BTC'];
        // массив полей сортировки для мобилы
        this.mobHeadings = ["market_position", "name", "price_usd", "price_usd_delta", "market_cap_usd", "available_supply", "volume_24_usd"];

        this.mob_wallets = ['BTC'];

        // межстрочные фильтры
        this.price_usd_filtres = ['total_supply'];
        this.price_usd_filtres_from = {
          name: 'price_usd_filtres_from',
          filters: ['volume_24_usd', 'market_cap_usd']
        }
        this.price_usd_filtres_to = {
          name: 'price_usd_filtres_to',
          filters: []
        }

        this.mobCrypto = ["all", "coins", "tokens"]; // массив фильтраций
      }
    } else if (this.table_section == 'wallets') {
      // массив полей (приходят из DOM-атрибутов)
      if (!this.isMobile) {
        this.columns = this.table_columns;
      } else {
        this.columns = this.table_columns_mob;
      }

      if (this.table_language == 'en') {
        this.options.headings = {
          name: 'Wallet',
          platforms: 'Platforms',
          currencies: 'Cryptocurrencies',
          private_key: 'Private key',
          is_opensource: 'Opensource',
          has_2fa: '2-factor auth',
        }


        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы
          this.mobHeadingsNames = {
            name: 'Wallet',
            platforms: 'Platforms',
            currencies: 'Cryptocurrencies',
          }
        }
      } else {
        this.options.headings = {
          name: 'Криптокошелек',
          platforms: 'Устройства',
          currencies: 'Криптовалюты',
          private_key: 'Приватный ключ',
          is_opensource: 'Открытый код',
          has_2fa: 'Двухфакторная авторизация',
        }


        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы
          this.mobHeadingsNames = {
            name: 'Криптокошелек',
            platforms: 'Устройства',
            currencies: 'Криптовалюты',
          }
        }
      }

      this.options.sortable = ["name"];
      this.options.filterable = ["name", "slug"];

      if (this.isMobile) {
        // массив полей сортировки
        this.mobHeadings = this.table_columns_mob;

        //this.mob_wallets = ['BTC'];

        // межстрочные фильтры
        //this.price_usd_filtres = ['currencies_count', 'volume_24_usd', 'volume_24_usd_delta', 'market_share'];
      }

      if (this.table_language == 'en') {
        this.filtersLang = {
          filters_hide:'Hide filters',
          filters_show:'Show filters',
          filters_reset:'Reset filters',
          currency:'Currency',
          currency_search:'Find currency',
          functionality:'Options',
          is_decentralized:'Decentralized',
          is_margin_trading:'Margin trading',
          is_derivatives:'Derivatives',
          fiat:'Fiats',
          pay:'Payment systems',
          country:'Country',
          language:'Languages',
          wallets_functionality:'Functionality',
          wallets_has_2fa_options:'2-factor authorization',
          wallets_has_multisignature_options:'Multisignature',
          wallets_has_newbie_alert_options:'For beginners',
          wallets_is_opensource_options:'Opensource',
          wallets_platforms:'Platforms',
          wallets_private_key_options:'Private key',
          has_buysell:'Buy&Sell',
          has_exchange:'Exchange',
          has_debitcard:'Debit Card',
        }
      }
      else {
        this.filtersLang = {
          filters_hide:'Скрыть фильтры',
          filters_show:'Показать фильтры',
          filters_reset:'Сбросить',
          currency:'Валюта',
          currency_search:'Поиск валюты',
          functionality:'Oпции',
          is_decentralized:'Децентрализованный',
          is_margin_trading:'Маржинальная торговля',
          is_derivatives:'Производные',
          fiat:'Фиаты',
          pay:'Платежные системы',
          country:'Страна',
          language:'Языки',
          wallets_functionality:'Сервисы',
          wallets_has_2fa_options:'Двухфакторная авторизация',
          wallets_has_multisignature_options:'Мультиподпись',
          wallets_has_newbie_alert_options:'Для начинающих',
          wallets_is_opensource_options:'Открытый код',
          wallets_platforms:'Устройства',
          wallets_private_key_options:'Приватный ключ',
          has_buysell:'Покупка',
          has_exchange:'Обмен валют',
          has_debitcard:'Дебетовая карта',
        }
      }
    } else if (this.table_section == 'exchanges') {
      // массив полей (приходят из DOM-атрибутов)
      if (!this.isMobile) {
        this.columns = this.table_columns;
      } else {
        this.columns = this.table_columns_mob;
      }

      if (this.table_language == 'en') {
        this.options.headings = {
          market_position: 'Rating',
          name: 'Exchange',
          country: 'Country',
          years: 'Years',
          currencies_count: 'Currencies',
          volume_24_usd: 'Volume',
          volume_24_usd_delta: 'Volume delta',
          market_share: 'Market share'
        }


        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы
          this.mobHeadingsNames = {
            market_position: 'Rating',
            name: 'Exchange',
            country: 'Country',
            years: 'Years',
            currencies_count: 'Currencies',
            volume_24_usd: 'Volume',
            volume_24_usd_delta: 'Volume delta',
            market_share: 'Market share'
          }
        }
      } else {
        this.options.headings = {
          market_position: 'Рейтинг',
          name: 'Биржа',
          country: 'Страна',
          years: 'Лет',
          currencies_count: 'Криптовалют',
          volume_24_usd: 'Объем торгов',
          volume_24_usd_delta: 'Изменение торгов',
          market_share: 'Доля рынка'
        }


        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы
          this.mobHeadingsNames = {
            market_position: 'Рейтинг',
            name: 'Биржа',
            country: 'Страна',
            years: 'Лет',
            currencies_count: 'Криптовалют',
            volume_24_usd: 'Объем торгов',
            volume_24_usd_delta: 'Изменение торгов',
            market_share: 'Доля рынка'
          }
        }
      }

      this.options.sortable = ["market_position", "name", "country", "years", "currencies_count", "volume_24_usd", "volume_24_usd_delta", "market_share"];
      //this.options.descOrderColumns = ["country", "years", "currencies_count", "volume_24_usd", "volume_24_usd_delta", "market_share"];
      this.options.filterable = ["name", "slug"];

      if (this.isMobile) {
        // массив полей сортировки
        this.mobHeadings = this.table_columns_mob;

        this.mob_wallets = ['BTC'];

        // межстрочные фильтры
        this.price_usd_filtres = ['currencies_count', 'volume_24_usd', 'volume_24_usd_delta', 'market_share'];
      }

      if (this.table_language == 'en') {
        this.filtersLang = {
          filters_hide:'Hide filters',
          filters_show:'Show filters',
          filters_reset:'Reset filters',
          currency:'Currency',
          currency_search:'Find currency',
          functionality:'Options',
          is_decentralized:'Decentralized',
          is_margin_trading:'Margin trading',
          is_derivatives:'Derivatives',
          fiat:'Fiats',
          pay:'Payment systems',
          country:'Country',
          language:'Languages',
        }
      }
      else {
        this.filtersLang = {
          filters_hide:'Скрыть фильтры',
          filters_show:'Показать фильтры',
          filters_reset:'Сбросить',
          currency:'Валюта',
          currency_search:'Поиск валюты',
          functionality:'Oпции',
          is_decentralized:'Децентрализованный',
          is_margin_trading:'Маржинальная торговля',
          is_derivatives:'Производные',
          fiat:'Фиаты',
          pay:'Платежные системы',
          country:'Страна',
          language:'Языки',
        }
      }

      //фильтр
    } else if (this.table_section == 'currencyItem_tabOne') {
      var table_code_heading = this.table_code.toUpperCase();
      var price_usd_heading = table_code_heading + '/USD';
      var price_second_heading = '';
      var price_btc_heading = '';

      if (this.table_language == 'en') {
        var exchange_name_heading = 'Exchange';
        var market_position_heading = 'Rating';
        var total_pairs_heading = 'Total ' + table_code_heading + ' pairs';
        var volume_24_heading = table_code_heading + ' volume';
        var market_share_heading = table_code_heading + ' market share';
      } else {
        var exchange_name_heading = 'Биржа';
        var market_position_heading = 'Рейтинг';
        var total_pairs_heading = 'Всего ' + table_code_heading + ' пар';
        var volume_24_heading = 'Объем ' + table_code_heading + ' торгов';
        var market_share_heading = 'Доля ' + table_code_heading + ' рынка';
      }

      if (this.table_code == 'btc') {
        this.table_columns.splice(3, 0, "price_euro");
        price_second_heading = table_code_heading + '/EUR';
      } else {
        price_second_heading = table_code_heading ;
        this.table_columns.splice(3, 0, "price_btc");
        price_btc_heading =  table_code_heading + '/BTC';
      }

      // массив полей (приходят из DOM-атрибутов)
      if (!this.isMobile) {
        this.columns = this.table_columns;
      } else {
        this.columns = this.table_columns_mob;
      }

      this.options.headings = {
        exchange_name: exchange_name_heading,
        market_position: market_position_heading,
        price_usd: price_usd_heading,
        price_btc: price_btc_heading,
        price_euro: price_second_heading,
        pairs_count: total_pairs_heading,
        volume_24: volume_24_heading,
        market_share: market_share_heading
      }

      if (this.isMobile) {
        // названия полей/сортировок/фильтров для мобилы
        this.mobHeadingsNames = {
          exchange_name: exchange_name_heading,
          market_position: market_position_heading,
          price_usd: price_usd_heading,
          price_btc: price_usd_heading,
          price_euro: price_second_heading,
          pairs_count: total_pairs_heading,
          volume_24: volume_24_heading,
          volume_24_usd: 'Vol(24h)',
          market_share: market_share_heading
        }
      }

      this.options.sortable = this.table_columns;
      //this.options.descOrderColumns = this.table_columns;
      this.options.descOrderColumns = ["exchange_name"];
      this.options.filterable = ["exchange_name", "symbol"];

      if (this.isMobile) {
        // массив полей сортировки
        if (this.table_code != 'btc') {
          this.mobHeadings = ["exchange_name", "price_usd", "volume_24_usd"];
        } else {
          this.mobHeadings = ["exchange_name", "price_usd", "price_euro", "volume_24_usd"];
        }

        // фильтры
        // this.mobCrypto = ["all", "coins", "tokens"];
      }
    } else if (this.table_section == 'currencyItem_tabTwo') {
      // массив полей (приходят из DOM-атрибутов)
      if (!this.isMobile) {
        this.columns = this.table_columns;
        this.columns.push('is_new');
      } else {
        this.columns = this.table_columns_mob;
        this.columns.push('is_new');
      }

      if (this.table_language == 'en') {
        let volume_24_usd_heading = 'Volume ' + this.table_currency.code;

        this.options.headings = {
          exchange_name: 'Exchange',
          symbol: 'Pair',
          price: 'Price',
          volume_24: 'Volume',
          volume_24_usd: volume_24_usd_heading,
          market_share: 'Share',
          is_new: 'Updated',
          price_usd: 'Price USD'
        }

        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы
          this.mobHeadingsNames = {
            exchange_name: 'Exchange',
            symbol: 'Pair',
            price: 'Price',
            market_share: 'Share',
            volume_24: 'Volume 24',
            volume_24_usd: 'Volume ' + this.table_currency.code.toUpperCase(),
            is_new: 'Updated',
            price_usd: 'Price USD'
          }
        }
      } else {
        let volume_24_usd_heading = 'Объем ' + this.table_currency.code;

        this.options.headings = {
          exchange_name: 'Биржа',
          symbol: 'Пара',
          price: 'Цена',
          volume_24: 'Объем',
          volume_24_usd: volume_24_usd_heading,
          market_share: 'Доля',
          is_new: 'Обновлено',
          price_usd: 'Цена USD'
        }

        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы
          this.mobHeadingsNames = {
            exchange_name: 'Биржа',
            symbol: 'Пара',
            price: 'Цена',
            market_share: 'Доля',
            volume_24: 'Объем 24 часа',
            volume_24_usd: 'Объем ' + this.table_currency.code.toUpperCase(),
            is_new: 'Обновлено',
            price_usd: 'Цена USD'
          }
        }
      }

      this.options.sortable = this.table_columns;
      //this.options.descOrderColumns = this.table_columns;
      this.options.filterable = ["exchange_name", "symbol"];

      if (this.isMobile) {
        this.mob_wallets = ['VOL'];

        // массив полей сортировки
        this.mobHeadings = ["exchange_name", "price", "volume_24", "volume_24_usd", "market_share"];
      }
    } else if (this.table_section == 'exchangeItem') {
      // массив полей (приходят из DOM-атрибутов)
      if (!this.isMobile) {
        this.columns = this.table_columns;
        this.columns.push('is_new');
      } else {
        this.columns = this.table_columns_mob;
        this.columns.push('is_new');
      }

      if (this.table_language == 'en') {
        let volume_24_usd_heading = 'Volume ' + this.table_currency.code;

        this.options.headings = {
          symbol: 'Name',
          price: 'Price',
          volume_24: 'Volume',
          volume_24_usd: volume_24_usd_heading,
          market_share: 'Exchange share',
          is_new: 'Updated'
        }

        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы
          this.mobHeadingsNames = {
            symbol: 'Pair',
            price: 'Price',
            market_share: 'Share',
            volume_24: 'Volume 24',
            volume_24_usd: 'Volume ' + this.table_currency.code.toUpperCase(),
            is_new: 'Updated '
          }
        }
      } else {
        let volume_24_usd_heading = 'Объем ' + this.table_currency.code;

        this.options.headings = {
          symbol: 'Пара',
          price: 'Цена',
          volume_24: 'Объем',
          volume_24_usd: volume_24_usd_heading,
          market_share: 'Доля',
          is_new: 'Обновлено'
        }

        if (this.isMobile) {
          // названия полей/сортировок/фильтров для мобилы
          this.mobHeadingsNames = {
            symbol: 'Пара',
            price: 'Цена',
            market_share: 'Доля',
            volume_24: 'Объем 24 часа',
            volume_24_usd: 'Объем ' + this.table_currency.code.toUpperCase(),
            is_new: 'Обновлено'
          }
        }
      }

      this.options.sortable = this.table_columns;
      //this.options.descOrderColumns = this.table_columns;
      this.options.descOrderColumns = ["volume_24_usd"];
      this.options.filterable = ["symbol"];

      if (this.isMobile) {
        this.mob_wallets = ['VOL'];

        // массив полей сортировки
        this.mobHeadings = ["symbol", "price", "volume_24", "volume_24_usd", "market_share"];
      }
    }

    this.tableDataGet();

    if (this.isMobile) {
      if (this.price_usd_filtres) {
        if (this.price_usd_filtres_from) {
          this.price_usd_filtres = this.price_usd_filtres.concat(this.price_usd_filtres_from.filters);
          this.price_usd_filtres_active = this.price_usd_filtres_from.name;
        }

        this.mobHeadings = this.mobHeadings.concat(this.price_usd_filtres); // объединяем массив полей с массивом межстрочной фильтрации

        // межстрочный фильтр при инициализации
        this.price_usd_filter = this.price_usd_filtres[0];
        this.price_usd_filter_heading = this.mobHeadingsNames[this.price_usd_filtres[0]];
      }

      this.mobHeadings = this.mobUniqueHeadings(this.mobHeadings); // удаляем повторяющиеся элементы

      // закидываем в валюты валюту из сессии
      if (this.mob_wallets != null && this.table_section != 'currencyItem_tabOne') {
        this.mob_wallets.unshift(this.table_currency.code);
        this.mobWallet = this.table_currency.code;
      }

      // мобильные табы
      // преобразуем элементы массива в объекты (name, params, section)
      // объекты нужны для сортировки/фильтрации и вывода соответствующей выборки в кнопках/попапах
      if (this.mobHeadings) {
        this.togglePopupData(this.mobHeadings, this.mobHeadingsNames);
      }
      if (this.mobCrypto) {
        this.togglePopupData(this.mobCrypto, this.mobHeadingsNames);
      }

      this.mobHeadings.forEach((item, index) => {
        this.options.sortable.push(this.mobHeadings[index].section);
        //this.options.descOrderColumns.push(this.mobHeadings[index].section);
      })

      this.selected_sort = this.mobHeadings[0].name;
      this.selected_sort_section = this.mobHeadings[0].section;
    }
  },
  mounted() {
    // if (this.table_language == 'en') {
    //   document.querySelectorAll(".VueTables__search-field input.form-control")[0].placeholder='Search';
    //   if(document.querySelectorAll(".VueTables__search-field input.form-control").length > 1) {
    //     document.querySelectorAll(".VueTables__search-field input.form-control")[1].placeholder='Search';
    //   }
    // } else {
    //   document.querySelectorAll(".VueTables__search-field input.form-control")[0].placeholder='Поиск';
    //   if(document.querySelectorAll(".VueTables__search-field input.form-control").length > 1) {
    //     document.querySelectorAll(".VueTables__search-field input.form-control")[1].placeholder='Поиск';
    //   }
    // }

    var props = this;

    var node = document.createElement("div");
    node.classList.add('VueTables__search-field__close');
    node.onclick = function () {
      $('.VueTables__search__input.form-control').val('')
      $('.VueTables__search').removeClass('closeActive');

      props.$root.$children.forEach(function (children, index) {
        if(children.$refs.table) {
          if(children.$refs.table.query) {
            children.$refs.table.query = '';
          }
        }
      });
    };

    var node2 = document.createElement("div");
    node2.classList.add('VueTables__search-field__close');
    node2.onclick = function () {
      $('.VueTables__search__input.form-control').val('')
      $('.VueTables__search').removeClass('closeActive');

      props.$root.$children.forEach(function (children, index) {
        if(children.$refs.table) {
          if(children.$refs.table.query) {
            children.$refs.table.query = '';
          }
        }
      });
    };

    document.querySelectorAll(".VueTables__search")[0].appendChild(node);
    if(document.querySelectorAll(".VueTables__search").length == 2 ){
      document.querySelectorAll(".VueTables__search")[1].appendChild(node2);
    }

    // устанавливаем наблюдателя в компонент библиотеки таблицы, который будет следить за направлением ascending сортировки (нужно для направления стрелки сортировки)
    if (this.isMobile) {
      this.$refs.table.$watch(
        'currentlySorting.ascending', (newVal, oldVal) => {
          this.ascending = newVal;
        }
      )
    }

    if (this.table_section == 'exchangeItem') {
      this.$refs.table.$watch(
        'allFilteredData', (newVal, oldVal) => {
          this.filteredData = newVal.length;

          if (newVal.length > this.options.perPage) {
            this.paginationDisable = true;
          } else {
            this.paginationDisable = false;
          }
        }
      )
    }

    if ((this.table_section == 'exchanges' || this.table_section == 'wallets') && this.table_filter_options_src) {

      this.$refs.table.$watch('allFilteredData', (newItems, oldItems) => {

          let showFilterReset = false;
          let filterReset = document.querySelector(".js-filter-reset");
          let filterOptions = document.querySelectorAll(".js-filter-wrap .filter__item input:not(.js-filter-search-input)");

          for (const option of filterOptions) {

            if(showFilterReset === false && option.checked === true) {
              showFilterReset = true;
            }

            let count = option.closest(".filter__field").querySelector(".filter__badge");
            let optionValue = option.value;
            let optionName = option.name;
            let currentCount = 0;

            for (const item of newItems) {

              if(Array.isArray(item[optionName]) && optionName !== 'platforms' && optionName !== 'language_wallets') {

                for (const itemOptionValue of item[optionName]) {

                  if(itemOptionValue == optionValue) {

                    currentCount++
                  }
                }
              } else if(optionName === 'language_wallets' && item['languages']){
                for (const itemOptionValue of item['languages']) {

                  if(itemOptionValue == optionValue) {

                    currentCount++
                  }
                }
              } else if(item[optionName] == optionValue) {
                currentCount++
              } else if(optionName === 'functionality' && item[optionValue]){
                  currentCount++
              } else if(optionName === 'platforms' && item[optionName]){
                for (const itemOptionValue of item[optionName]) {

                  if(itemOptionValue.id == optionValue) {

                    currentCount++
                  }
                }
              } else if(optionName === 'functionality_wallets' && item['functionality']){
                for (const itemOptionValue of item['functionality']) {

                  if(itemOptionValue == optionValue) {

                    currentCount++
                  }
                }
              }
            }

            count.textContent = currentCount;
          }

          if(showFilterReset) {
            filterReset.style.display = 'inline-block';
          } else {
            filterReset.style.display = 'none';
          }
        }
      )
    }

    window.vue_custom = this;
    window.vue_event = Event;
  },
  updated() {

    if(this.mobPopup) {
      $('.header__row.pagination__scroll.scroll').hide();
      $('.button-top').hide();
    }
    else {
      $('.header__row.pagination__scroll').show();
      $('.header__row.pagination__scroll.scroll').show();
      $('.button-top').show();
    }
    if (!this.tableReady) {
      let width = $('.VueTables__table').width()
      let $cells = $('.VueTables__table').find("tr").eq(1).find("td")
      let sum = 0
      $cells.each(function(index) {
        let $el = $(this)
        let widthPercentage = Math.round($el.width() / width * 100)
        sum += widthPercentage
        if(index == $cells.length - 1 && sum < 100) {
          widthPercentage += (100 - sum)
          sum = 100
        }
        $el.attr('width', widthPercentage + '%')
      })
      if(this.exchangesFiltres.length > 0) {
        $(".js-swipe-scroller_vue").trigger('vue-swiper');
      }

      this.tableReady = true;

      if((this.table_section == 'exchanges' || this.table_section == 'wallets') && this.table_filter_options_src && $(".js-filter-scroll").length) {

        let $scroll = $(".js-filter-scroll")

        $scroll.mCustomScrollbar({
          setWidth: false,
                setHeight: false,
                setTop: 0,
                axis: "y",
                scrollbarPosition: "outside",
                scrollInertia: 400,
                autoDraggerLength: true,
                autoHideScrollbar: false,
                autoExpandScrollbar: false,
                alwaysShowScrollbar: 0,
                snapAmount: null,
                mouseWheel: {
                    enable: true,
                    scrollAmount: "auto",
                    axis: "y",
                    preventDefault: true,
                    deltaFactor: 40,
                    normalizeDelta: 1,
                    invert: false,
                    disableOver: ["select", "option", "keygen", "datalist", "textarea"]
                },
                scrollButtons: {
                    enable: false,
                    scrollType: "stepless",
                    scrollAmount: "auto"
                },
                keyboard: {
                    enable: true,
                    scrollType: "stepless",
                    scrollAmount: "auto"
                },
                contentTouchScroll: 25,
                advanced: {
                    autoExpandHorizontalScroll: false,
                    autoScrollOnFocus: "input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",
                    updateOnContentResize: true,
                    updateOnImageLoad: true,
                    updateOnSelectorChange: false,
                    releaseDraggableSelectors: false
                },
                callbacks: {
                    onInit: false,
                    onScrollStart: false,
                    onScroll: false,
                    onTotalScroll: false,
                    onTotalScrollBack: false,
                    whileScrolling: false,
                    onTotalScrollOffset: 0,
                    onTotalScrollBackOffset: 0,
                    alwaysTriggerOffsets: true,
                    onOverflowY: false,
                    onOverflowX: false,
                    onOverflowYNone: false,
                    onOverflowXNone: false
                },
                live: false,
                liveSelector: null
        })
        $(".js-filter-search").filterSearch();
      }
    }
  }
};
</script>
